var currentAutoloadingSearchID = 0; // searchID of the tab pane currently doing auto loading, or 0 if none is auto loading

// Enumeration to indicate what triggered the current onLoadNext event
var AUTOLOAD_EVENT = {
    'CONTINUE': 'continue',
    'TAB_SWITCH': 'tabSwitch',
    'ON_LOAD_MORE': 'onLoadMore'
};

var phoneBookXHR = {};
var landValidationsWidget = null;

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

// Set up all our event listeners
$(function () {
    // Using anonymous function because the click event will be passed to loadChain

    $('#saved-selection').on('change', function () {
        loadNewTab($("#saved-selection").val(), true, window);
        this.selectedIndex = 0;
    });

    $('#order_filter_dropdown').on('click', function (e) {
        e.stopPropagation();
        if ($(e.target).attr('class') === 'dropdown-item') {
            var checkbox = $(e.target).find('input');
            checkbox.prop('checked', !checkbox.prop('checked'));
        }
    });

    $('#duplicate_order').on('click', function () {
        $('#duplicateOrderModal').modal('show');

        // Have to set timeout to get the modal time to open
        setTimeout(function () {
            $('#duplicate_order_title').focus();
        }, 200);
    });

    $('.duplicate_order_from_order_page').on('click', function () {
        $('#duplicateOrderModal').modal('show');

        var orderId = $(this).data('order-id');

        // Have to set timeout to get the modal time to open
        setTimeout(function () {
            $('#duplicate_order_title').focus();
            $('.btn-modal-duplicate-order-from-orders-page').data('order-id', orderId);
        }, 200);
    });

    $('.btn-modal-duplicate-order').on('click', function () {
        duplicateOrder(getOrderId());
    });

    $('.btn-modal-duplicate-order-from-orders-page').on('click', function () {
        duplicateOrder($(this).data('order-id'), true);
    });

    $('.btn-save-search').on('click', function () {
        $('#saveSearch-' + getSelectedSearchId()).modal('show');

        // Have to set timeout to get the modal time to open
        setTimeout(function () {
            var searchId = getSelectedSearchId();

            if (searchId === 0) {
                $('#order_type_' + getSelectedSearchId() + '_order_title').focus().select();
                return;
            }

            $('#order_type_' + getSelectedSearchId() + '_search_title').focus().select();
        }, 200);
    });


    // used to flag and unflag selected items
    $('.btn-flag-unflag').on('click', async function () {
        const selectedResultIds = getSelectedResultIdsOnCurrentTab();
        await toggleFlaggedFlagMultiple(selectedResultIds);
        unselectAll();
    });


    // used to hide and show selected items
    $('.btn-strikethrough').on('click', async function () {
        const selectedResultIds = getSelectedResultIdsOnCurrentTab();
        await toggleStrikeOutFlagMultiple(selectedResultIds);
        selectedResultIds.forEach(function (resultId) {
            falloutDisplayAction(resultId);
        });
        unselectAll();
    });

    // opens all selected documents
    $('.btn-display-all').on('click', function () {
        const selectedResultIds = getSelectedResultIdsOnCurrentTab();
        addResultsToImageViewer(selectedResultIds);
        unselectAll();
    });

    // expands all documents
    $('.btn-expand-all').on('click', function () {
        expandAll();
    });

    // selects all documents
    $('.btn-select-all-with-strikes').on('click', function () {
        selectAll();
    });

    // selects all documents
    $('.btn-select-all-no-strikes').on('click', function () {
        selectAllNoStrikes();
    });


    $('.btn-create-edit-doc-note').on('click', function () {
        createEditDeleteDocNote(false);
    });

    $('.btn-delete-doc-note').on('click', function () {
        createEditDeleteDocNote(true);
    });

    $('.btn-watch-for-release').on('click', function () {
        setWatches($('#myTab'), '', '', '');
    });

    // removes fallout notifications
    $('.btn-remove-fallout-notifications').on('click', function () {
        removeFalloutNotifications();
    });

    // $('.btn-export').on('change', function () {
    //     exportSelect();
    // });

    // Open existing search
    $('.table .btn-open-search').on('click', function (e) {
        e.preventDefault();
        openWindow('/documents/?searchId=' + $(this).data('search-id'));
    });

    // Open existing Order
    $('.table .btn-open-order').on('click', function (e) {
        e.preventDefault();
        openWindow('/documents/?orderId=' + $(this).data('order-id'));
    });

    //Refresh Existing Search
    $('.table .btn-refresh-search').on('click', function (e) {
        e.preventDefault();
        openWindow('/searches/refresh/?searchId=' + $(this).data('search-id'));
    });

    //Refresh Existing Order
    $('.table .btn-refresh-order').on('click', function () {
        // openWindow('/orders/refresh/?orderId=' + $(this).data('order-id'));
    });

    $('#search-form').find('input').keydown(function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            searchDocuments();
        }
    });

    $('.btn-copy-order').on('click', copyOrder);

    $('.btn-add-remove-final').on('click', async function () {
        const selectedResultIds = getSelectedResultIdsOnCurrentTab();
        await toggleInFinalChainFlagMultiple(selectedResultIds);
        selectedResultIds.forEach(function (resultId) {
            falloutDisplayAction(resultId);
        });
        unselectAll();
    });

    $('.btn-modal-save-selection').on('click', saveChain);
    $('.btn-modal-save-search').on('click', saveSearch);

    $('.btn-modal-email-selection').on('click', emailSelection);

    //applyTabJavaScript to each tab pane in our document
    $(".tab-pane").each(function () {
        applyTabJavaScript($(this));
    });


    $(".run_fallout_checkbox").on('click', function (event) {
        updateRunFallout($(this).data('search-id'), $(this).is(":checked"));
    });

    // Custom logic for showing/hiding tabs. Default BS4 logic was being buggy
    $('#myTab').on('click', '.search-tab-button', function (e) {
        e.stopPropagation();
        const searchId = $(this).data('searchId');
        switchTab(searchId);
    });

    // Just hide the error box, do not remove it completely
    $('.alert-save').find('.close').on('click', hideError);

    $(document).mouseup(function () {
        isMouseDown = false;
    });

    $('.auto-complete').select2({width: '100%'});

    $('.search-tab-button:first').trigger('click');

    $(document).on('click', '.land-validations-widget-button', function (e) {
        e.preventDefault();

        if (landValidationsWidget && !!landValidationsWidget.window) {
            landValidationsWidget.focus();
        } else {
            let features = 'height='+(window.screen.height*.66)+',width=700,resizable=yes';
            let url = '/land-validations-widget';
            landValidationsWidget = window.open(url, 'landValidationsWidget', features);
        }
    });

    $(document).on('click', '.request-missing-document', function () {
        $('#request-missing-document-instrument-number').val($(this).data('instrument-number'));
        $('#request-missing-document-modal .lds-spinner').addClass('hide');
        $('#request-missing-document-content').removeClass('hide');
        $('#request-missing-document-save').prop('disabled', false);

        $('#request-missing-document-modal').modal('show');
    });

    $('#request-missing-document-save').click(function () {
        $('#request-missing-document-modal .lds-spinner').removeClass('hide');
        $('#request-missing-document-content').addClass('hide');
        $('#request-missing-document-save').prop('disabled', true);

        let data = {
            instrument_number: $('#request-missing-document-instrument-number').val()
        };

        let referenceNumber = $('#request-missing-document-reference-number').val();
        if (referenceNumber) {
            data['reference_number'] = referenceNumber;
        }

        $.ajax({
            type: 'POST',
            url: '/searches/request-missing-document',
            data: data,
            success: function (r) {
                bootbox.alert(r.message);
            },
            error: function (r) {
                bootbox.alert('There was an error with the post ' + r);
            },
            complete: function () {
                $('#request-missing-document-modal').modal('hide');
            }
        });
    });

    $(document).on('click', '.btn-tag', function () {
        var selection = $("#searching-tab-" + getSelectedSearchId()).find('.selected:checked');
        if (selection.length === 0) {
            alert('please select at least one document');
            return;
        }

        var documentIds = [];
        selection.each(function () {
            documentIds.push($(this).val());
        });

        addDocTags(documentIds);
    });

    $('#tag-modal-save').click(function (e) {
        e.preventDefault();

        let tags = [];
        $(".tag-documents-tags:checked").each(function(){
            tags.push($(this).val());
        });

        let documentIds = JSON.parse($('#tag-documents-ids').val());

        if (tags.length === 0 || documentIds.length === 0) {
            return;
        }

        $('#tag-documents-modal .lds-spinner').removeClass('hide');
        $('#tag-documents-content').addClass('hide');
        $('#tag-modal-save').prop('disabled', true);

        let data = {
            document_ids: documentIds,
            tags: tags,
        };

        let referenceNumber = $('#tag-documents-reference-number').val();
        if (referenceNumber) {
            data['reference_number'] = referenceNumber;
        }

        $.ajax({
            type: 'POST',
            url: '/documents/tags/',
            data: data,
            success: function (r) {
                bootbox.alert(r.message);
            },
            error: function (r) {
                bootbox.alert('There was an error with the post ' + r);
            },
            complete: function () {
                $('#tag-documents-modal').modal('hide');
            }
        });
    });

    $(document).on('click', '.btn-create-batch', function () {
        var searchId = getSelectedSearchId();

        createBatchFromSearch(searchId);
    });

    $('#create-batch-modal-save').click(function (e) {
        e.preventDefault();

        let data = {
            searchId: $('#batch-search-id').val(),
            name: $('#batch-name').val()
        }

        $.ajax({
            type: 'POST',
            url: '/documents/create-batch/',
            data: data,
            success: function (r) {
                if (r.id !== null) {
                    bootbox.alert('A batch is being created from this search');
                } else {
                    bootbox.alert('There was a problem creating a batch from this search');
                }
            },
            error: function (r) {
                bootbox.alert('There was a problem creating a batch from this search: error communicating with indexing');
            },
            complete: function () {
                $('#create-batch-from-search-modal').modal('hide');
            }
        });
    });

    $('.refresh-tax-request').click(function () {
        let taxRequestId = $(this).data('tax-request-id');
        $(this).html('<i class="fas fa-spinner fa-spin ml-1"></i>')

        $.post('/tax-requests/' + taxRequestId + '/refresh', function () {
            window.location.reload();
        });
    });
}); // end $(function())

function duplicateOrder(orderId, openInNewTab = false) {
    var newTitle = $('#duplicate_order_title').val();

    $('#duplicate_order_loading').show();
    $(this).prop('disabled', true);
    $('.btn-modal-cancel-duplicate-order').prop('disabled', true);
    $('#duplicate_order_message').hide();

    $.get('/orders/duplicate/?orderId=' + orderId + '&newTitle=' + newTitle).then(function (result) {
        $('.btn-modal-duplicate-order').prop('disabled', false);
        $('.btn-modal-cancel-duplicate-order').prop('disabled', false);
        $('#duplicate_order_loading').hide();

        if (result.success) {
            $('#duplicate_order_message').removeClass('text-danger').addClass('text-success').text(result.message).show();
            if (openInNewTab) {
                window.open('//' + result.url, '_blank');
                location.reload();
                return;
            }

            window.location.href = '//' + result.url;

        } else {
            $('#duplicate_order_message').text(result.message).show();
        }
    });
}

function deleteSearch(searchId) {
    // see if it has any documents in the final chain
    var chainLinks = $('#searching-tab-' + searchId + ' [data-chain="1"]');

    if (chainLinks.length > 0) {
        if (!confirm('This search has a document in the final chain.  Delete anyways?')) {
            return;
        }
    } else {
        if (!confirm('Are you sure you want to delete this tab?')) {
            return;
        }
    }

    // delete
    window.open('/searches/deleteSearch/?searchId=' + searchId, "_self");
}


function unselectAll() {
    $(".selected").attr('checked', false); //change all ".selected" checked status to false
}

function changeNotificationDisplay(resultRow, notification) {
    // find the div that displays this item
    var note_div = resultRow.find('.' + notification + '-div');
    // find the current flag
    var oldState = $(note_div).data(notification);
    // find the new flag
    var newState = 1 - oldState;

    return setNotificationDisplay(resultRow, notification, newState)
}

function setNotificationDisplay(resultRow, notification, newState) {
    // find the div that displays this item
    var note_div = $(resultRow).find('.' + notification + '-div');
    var note_icon = $(note_div).find('i');

    var oldClass = 'click_icon';
    var newClass = 'unclicked_icon';

    if (newState === 1) {
        oldClass = 'unclicked_icon';
        newClass = 'click_icon';
    }

    $(note_icon).removeClass(oldClass);
    $(note_icon).addClass(newClass);

    // save the new data
    $(note_div).data(notification, newState);

    return newState;
}

function sendNotification(documents, notification) {
    // encode
    var dataString = 'data=' + JSON.stringify(documents) + '&notification=' + notification;

    // send it on over
    $.ajax({
        type: 'GET',
        url: '/searches/saveNotifications/',
        data: dataString,
        success: function (response) {
            console.log(response)
        },
        error: function (response) {
            alert('there was an error with the post ' + response);
        }
    });
}

async function falloutDisplayAction(resultId) {
    // One for new fallout, one for history
    const hasUnprocessedFallout = $(`tr[data-result-id="${resultId}"][data-search-id="0"]`).length > 1;

    if (!hasUnprocessedFallout) {
        console.log('Ignored fallout action');
        return;
    }

    await setNewAddition(resultId);
    syncFlagStateForMatchingDocuments(resultId);
    if ($('#searching-tab-0').find('#document-table').find('#' + resultId + '-details-1').is(':visible')) {
        expandDetails(resultId, 'fallout-hidden');
    }
}

function falloutToggleNotifications(resultId) {
    $('tr[data-result-id="' + resultId + '"]').each(function () {
        toggleStrikeNotificationForADoc($(this), $(this).data('searchId') === 0)
    });
}

function toggleFalloutNotification(notification, selected) {
    var documents = [];
    var documentId = selected.data('documentId');

    selected.each(function () {
        var newData = changeNotificationDisplay($(this), notification);

        // find the search id ( this may change to parent
        var searchId = $(this).data('search-id');
        // get the document id, maybe put search id here as well?

        // create a new JSON object and push it to the array
        documents.push({"document_id": documentId, "search_id": searchId, notification: newData});
    });

    unselectAll();
    sendNotification(documents, notification);
}

function clearFalloutClasses(resultId) {
    $('tr[data-result-id="' + resultId + '"]').each(function () {
        if ($(this).hasClass('fallout-hidden') && $(this).data('searchId') !== 0) {
            console.log(`Found real doc for ${resultId}`);
            $(this).removeClass('fallout-hidden');
            $(this).addClass('fallout-reveal');
        } else if ($(this).hasClass('new-fallout')) {
            console.log(`Found new fallout for ${resultId}`);
            $(this).removeClass('new-fallout');
            $(this).addClass('fallout-hidden');
        } else if ($(this).hasClass('fallout-history-hidden')) {
            console.log(`Found history fallout for ${resultId}`);
            $(this).removeClass('fallout-history-hidden');
            $(this).addClass('fallout-history');
        }
    });
}


function getDocumentCount(searchId) {

    const orderId = getOrderId();

    // send it on over
    $.ajax({
        type: 'GET',
        url: '/searches/getDocumentNumberWithFallout/',
        data: {orderId: orderId, searchId: searchId},
        success: function (response) {
            handleDocumentCount(response, searchId);
        },
        error: function (response) {
            alert('there was an error with the post ' + response);
        }
    });
}

function handleDocumentCount(data, searchId) {
    $('#document-count-' + searchId).text(data['number']);
}

async function setNewAddition(resultId) {
    // send it on over
    try {
        const response = await $.get('/searches/setNewAdditionAndRemoveNotes/', {results: [{resultId: resultId}]});
        getDocumentCount(0);
        for (const searchId of response['affectedSearchIds']) {
            console.log('Refreshing count for: ' + searchId);
            getDocumentCount(searchId);
        }
        for (const processedResultId of response['processedResultIds']) {
            console.log('Updating fallout display for: ' + processedResultId);
            changeNotesForHistoryFalloutDoc(processedResultId, response['note']);
            clearFalloutClasses(processedResultId);
        }


    } catch (e) {
        alert('There was an error with clearing fallout status' + e);
    }
}

function changeNotesForHistoryFalloutDoc(resultId, note) {
    const historyTable = $('#document-history-table');
    const historyRow = historyTable.find(`.document-summary[data-result-id="${resultId}"]`);
    const notesSpan = historyRow.find('#document-notes');
    notesSpan.text(note);
}

function checkIfWatchIsValidated(orderId, documentId) {
    var data = [];
    data.push({"document_id": documentId, "order_id": orderId});
    var dataString = 'data=' + JSON.stringify(data);

    // send it on over
    $.ajax({
        type: 'GET',
        url: '/orders/validateWatch/',
        data: dataString,
        success: function (response) {
        },
        error: function (response) {
            alert('there was an error with the post ' + response);
        }
    });
}

function setOneWatch(resultId) {
    var orderId = getOrderId();
    var searchId = getSelectedSearchId();
    var root = $('.document-summary[data-result-id="' + resultId + '"]');
    var documentId = root.data('documentId');

    setWatches(root, searchId, documentId, orderId)
}


function setWatches(root, possible_search_id, possible_document_id, possible_order_id) {

    var orderId = $("#order_id").val();
    var searchId = getSelectedSearchId();
    var selected = $("#searching-tab-" + getSelectedSearchId()).find('.selected:checked');
    var documents = [];

    if (possible_search_id !== '') {
        documents.push(possible_document_id);
        searchId = possible_search_id;
        selected = $(root).parent().find('#selected_' + possible_document_id);
        orderId = possible_order_id;
    } else {
        if (selected.length === 0) {
            console.log("nothing selected");
            return;
        }

        selected.each(function () {
            var documentId = $(this).val();
            documents.push(documentId);
        });
    }

    var data = {
        orderId: orderId,
        searchId: searchId,
        documents: documents
    };

    $.ajax({
        type: 'GET',
        url: '/documents/setWatches/',
        data: data,
        success: function (response) {
            toggleWatches(selected);
            getOrderStatus();
        },
        error: function (response) {
            console.log('Failed to set watches. Please refresh the page.');
            console.log(response.responseText);
        }

    });

    unselectAll();

}

function getOrderStatus() {
    orderId = getOrderId();

    $.ajax({
        type: 'POST',
        url: '/orders/getOrderStatus/',
        data: {orderId: orderId},
        success: function (response) {
            changeCloseButton(response);
        }
    });
}

function changeCloseButton(data) {
    const status = data['status'];

    if (status === 'open_no_watches') {
        $('#order-close-button').text('Close');
        $('#order-close-button').attr('class', 'dropdown-item close-order');
    } else if (status === 'open_with_watches') {
        $('#order-close-button').text('Watch');
        $('#order-close-button').attr('class', 'dropdown-item watch-order');
    } else if (status === 'waiting_for_watches') {
        $('#order-close-button').text('Watching');
        $('#order-close-button').attr('class', 'dropdown-item watching');
    } else if (status === 'ready_for_close') {
        $('#order-close-button').text('Final Close');
        $('#order-close-button').attr('class', 'dropdown-item final-close');
    } else if (status === 'closed') {
        const parent = $('#order-close-button').parent();
        $('#order-close-button').remove();
        parent.append('Closed');
    }
}

$('.search-footer').find('#order-close-button').on('click', function () {
    const childclass = $(this).attr('class');
    if (childclass.includes('close-order')) {
        if (confirm('This order has no watches, are you sure you still want to close it?') === true) {
            window.location.replace("/orders/close/?orderId=" + getOrderId());
        }
    } else if (childclass.includes('watch-order')) {
        window.location.replace("/orders/close/?orderId=" + getOrderId() + "&new_state=waiting_for_watches");
    } else if (childclass.includes('watching')) {
        alert('This order is still waiting for watches.');
    } else if (childclass.includes('final-close')) {
        if (confirm('Are you sure you want to close this order') === true) {
            window.location.replace("/orders/close/?orderId=" + getOrderId());
        }
    }
});


function toggleWatches(documents) {
    documents.each(function () {

        const documentId = $(this).val();

        $('.document-summary[data-document-id="' + documentId + '"]').each(function () {
            changeNotificationDisplay($(this), 'watch');
        });
    });
}

function createEditDeleteDocNote(deleteNote) {
    // find selected
    var tab = $("#searching-tab-" + getSelectedSearchId());
    var selection = $(tab).find('.selected:checked');
    // we need only one document
    if (selection.length > 1) {
        alert('too many documents selected');
        return;
    }
    if (selection.length === 0) {
        alert('please select at least one document');
        return;
    }

    //need to get document id
    var select = selection[0];
    var document_id = $(select).val();
    editDocNote(document_id, deleteNote, tab);
}

function editDocNoteFromIcon(document_id) {
    var parent = $("#searching-tab-" + getSelectedSearchId());
    var deleteNote = false;

    editDocNote(document_id, deleteNote, parent);

}

function editDocNote(document_id, deleteNote, parent) {
    var dataString = 'documentId=' + document_id;

    if (deleteNote) {
        dataString = dataString + "&delete=" + deleteNote;
        $.post('/documents/stickyNote/', dataString, function (response) {
            changeNoteDisplay(document_id, parent, deleteNote, response);
        });
        unselectAll();
        return;
    }

    // openWindow('/documents/stickyNote/?' + dataString);

    // get the data
    $.post('/documents/stickyNote/', dataString, function (data) {
        $("#sticky_note_modal_content").html(data);
        $('#sticky_note_modal').modal('show');
        $("#sticky_note_modal_content form").submit(function (event) {
            // prevent the default submit from happening
            event.preventDefault();

            var data = $(this).serialize();

            // post a response to the controller, but capture its output.  Don't redirect!
            $.post('/documents/stickyNote/', dataString + '&' + data, function (response) {
                if (response.add_icon) {
                    changeNoteDisplay(document_id, parent, deleteNote, response);
                }
                $('#sticky_note_modal').modal('hide');
            });

        });

    });
    unselectAll();
}


function changeNoteDisplay(document_id, parent, deleteNote, response) {

    var newIconClass = "unclicked_icon";
    var oldIconClass = "sticky_click_icon";
    var newNoteHtml = "";

    if (!deleteNote) {
        newIconClass = "sticky_click_icon";
        oldIconClass = "unclicked_icon";

        newNoteHtml = "<div class=\"row\"><strong><u>Sticky Note:</u></strong></div> " + response.message;
    }

    var icon = $(parent).find('#sticky_icon_' + document_id);
    icon.removeClass(oldIconClass);
    icon.addClass(newIconClass);

    var stickyText = $(parent).find('#sticky_text_' + document_id);
    stickyText.html(newNoteHtml);
}

function displayAll() {
    // get all selected documents
    var tab = $("#searching-tab-" + getSelectedSearchId()).find('.selected:checked');

    if (tab.length === 0) {
        console.log("nothing to display here");
        return;
    }

    //visit each document and display it
    tab.each(function () {
        // see if a display document icon is present
        var icon = $(this).parents('tr').find('#display_document_icon');

        // if so, this document is safe to display
        if (icon.length === 1) {
            var searchId = $(this).parents('tr').data('search-id');
            if (searchId == 0) {
                $('tr[data-document-id="' + $(this).val() + '"]').each(function () {
                    if ($(this).data('searchId') != 0) {
                        searchId = $(this).data('searchId');
                    }
                });
            }
            var result = displayDocument($(this).val(), $("#order_id").val(), searchId);

            // window.open will return null after the first call to prevent popups.
            if (result === null) {
                alert('Please disable pop-up blockers in your brower\'s settings OR add this site to the list of trusted exceptions');
                return false;// exits the each early. no reason to stick around, all other calls to window.open will return null
            }
        }
    });

    unselectAll();

}

function exportLinks() {
    var selection = $("#searching-tab-" + getSelectedSearchId()).find('.selected:checked');

    // create documents
    var documents = [];

    selection.each(function () {
        var icon = $(this).parents('tr').find('#display_document_icon');

        // if so, this document is safe to export
        if (icon.length === 1) {

            // I need document id, and if expanded or not.
            // get the document id,
            var document_id = $(this).val();

            // create a new JSON object and push it to the array
            documents.push(document_id);
        }
    });


    var dataString = 'data=' + JSON.stringify(documents);

    // get the data
    $.post('/documents/exportLinks/', dataString, function (data) {
        $("#link_export_modal_content").html(data);
        $('#link_export_modal').modal('show');

    });

    unselectAll();

}

function getSelectedDocumentIds() {

    var documents = [];

    $('.document-summary').each(function () {
        if ($(this).find('.selected').prop('checked')) {
            documents.push($(this).data('documentId'))
        }
    });

    return documents;
}


function copyToClipboard(text) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
}


function openWindowWithPost(url, data) {
    var form = document.createElement("form");
    form.target = "_blank";
    form.method = "POST";
    form.action = url;
    form.style.display = "none";

    for (var key in data) {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = data[key];
        form.appendChild(input);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}

// toggle selecting or unselecting all documents
function selectAll() {

    var tab = $("#searching-tab-" + getSelectedSearchId());
    var button = $(".btn-select-all-with-strikes");

    // find all the check boxes
    var checks = $(tab).find('tr').find('.selected');

    if (button.html().indexOf("fa-check-square") >= 0) {
        $(button).html("<i class=\"fa fa-square\" aria-hidden=\"true\"></i> <i class=\"fa fa-plus\" aria-hidden=\"true\"> <i class=\"fa fa-strikethrough\" aria-hidden=\"true\"></i>");
        $(checks).prop('checked', true);
    } else {
        $(button).html("<i class=\"fa fa-check-square\" aria-hidden=\"true\"></i> <i class=\"fa fa-plus\" aria-hidden=\"true\"> <i class=\"fa fa-strikethrough\" aria-hidden=\"true\"></i>");
        $(checks).prop('checked', false);
    }
}

// toggle selecting or unselecting all documents w/o strike through
function selectAllNoStrikes() {

    var tab = $("#searching-tab-" + getSelectedSearchId());
    var button = $(".btn-select-all-no-strikes");

    // find all the check boxes
    var checks = $(tab).find('tr:not([class*=strikeout])').find('.selected');

    if (button.html().indexOf("fa-check-square") >= 0) {
        $(button).html("<i class=\"fa fa-square\" aria-hidden=\"true\"></i> <i class=\"fa fa-minus\" aria-hidden=\"true\"> <i class=\"fa fa-strikethrough\" aria-hidden=\"true\"></i>");
        $(checks).prop('checked', true);
    } else {
        $(button).html("<i class=\"fa fa-check-square\" aria-hidden=\"true\"></i> <i class=\"fa fa-minus\" aria-hidden=\"true\"> <i class=\"fa fa-strikethrough\" aria-hidden=\"true\"></i>");
        $(checks).prop('checked', false);
    }
}


// sends a call to the controller to remove fallout notifications from the search
function removeFalloutNotifications() {
    // get search ID
    var searchId = getSelectedSearchId();
    // create the data string
    var dataString = "searchId=" + searchId;

    // call to the controller
    $.ajax({
        type: 'GET',
        url: '/search/removeFalloutNotifications/',
        data: dataString,
        success: function () {
            window.location.reload();  // I tried reload tab, but it put the reloaded tab in the back
        },
        error: function (response) {
            alert('there was an error with the post ' + response);
        }
    });
}


// toggle between expanding all or collapsing document details.
function expandAll() {
    // find the tab we are working with
    var tab = $("#searching-tab-" + getSelectedSearchId());
    // all the trs for all the documents
    var docs = $(tab).find("[id^=document_]");
    // the toggle arrows
    var toggles = $(tab).find("table").find("[id$=-details-toggle]");
    // the hidden details of each document
    var details1 = $(tab).find("table").find("[id$=-details-1]");
    var details2 = $(tab).find("table").find("[id$=-details-2]");
    var button = $(".btn-expand-all");

    if (button.html().indexOf("fa fa-expand") >= 0) {  // Expand all
        // change button text
        $(button).html("<i class=\"fa fa-compress\" aria-hidden=\"true\"></i>");
        // swap arrows
        $(toggles).removeClass('fa fa-arrow-down');
        $(toggles).addClass('fa fa-arrow-up');
        // mark the tr as expanded
        $(docs).addClass('expanded');
        // fade the details in
        $(details1).fadeIn();
        $(details2).fadeIn();
        $(docs).find('.header-placeholder').addClass('header');
        $(docs).find('.header').fadeIn();
        $(docs).children('td').addClass('body-padding');
        addRemoveBorders([{Class: '.grantor-col', direction: 'add', side: 'left'},
            {Class: '.grantee-col', direction: 'add', side: 'right'},
            {Class: '.legal-col', direction: 'add', side: 'left'},
            {Class: '.legal-col', direction: 'add', side: 'right'}], $(docs));
        updateAllResultFlags(getSelectedSearchId(), {expanded: true});
    } else { // collapse all
        $(button).html("<i class=\"fa fa-expand\" aria-hidden=\"true\"></i>");
        $(toggles).removeClass('fa fa-arrow-up');
        $(toggles).addClass('fa fa-arrow-down');
        $(docs).removeClass('expanded');
        $(details1).fadeOut();
        $(details2).fadeOut();
        $(docs).find('.header-placeholder').removeClass('header');
        $(docs).find('.header').fadeOut();
        $(docs).children('td').removeClass('body-padding');
        addRemoveBorders([{Class: '.grantor-col', direction: 'remove', side: 'left'},
            {Class: '.grantee-col', direction: 'remove', side: 'right'},
            {Class: '.legal-col', direction: 'remove', side: 'left'},
            {Class: '.legal-col', direction: 'remove', side: 'right'}], $(docs));
        // $("#tool-tip-text").html("");
        updateAllResultFlags(getSelectedSearchId(), {expanded: false});
    }
}


function applyTabJavaScript(root) {
    // Bind load-more button to run onLoadMore when clicked.
    root.find('.load-more').off('click').on('click', onLoadMore);
    root.find('.search-results').off('click').on('click', '.close-tab', function () {
        closeTab($(this).data('tab-id'), window);
    });

    root.find('.document-summary').off('click').on('click', function (e) {
        var resultId = $(this).data('result-id');
        var parentClass = $(this).attr('class');
        expandDetails(resultId, parentClass);
    });

    root.find('.notification-td').off('click').on('click', function (e) {
        e.stopPropagation();
    });

    root.find('.btn-view-document').off('click').on('click', function () {  // this is a button
        const resultId = $(this).data('resultId');
        addResultToImageViewer(resultId);
    });

    root.find('.btn-remove-document').off('click').on('click', function () {  // this is a button
        window.open('/searches/remove-document/?documentId=' + $(this).data('document-id') + '&orderId=' + $(this).data('order-id') + '&searchId=' + $(this).data('search-id'), '_blank');
    });

    root.find('.btn-order-from-doc').off('click').on('click', function () {
        window.open('/documents/create-order-from-doc/?documentId=' + $(this).data('document-id') + '&orderId=' + $(this).data('order-id') + '&searchId=' + $(this).data('search-id'), '_blank');
    });

    //set the display_Search_filter_toggle button's listener to be toggleSearchFilter
    root.find('#display_search_filter_toggle').off('click').on('click', function (event) {
        toggleSearchFilter(root);
    });

    root.find('.view-image-div').off('click').on('click', function (e) {
        e.stopPropagation();
        const resultId = $(this).data('resultId');
        addResultToImageViewer(resultId);
    });

    root.find('.strike-div').off('click').on('click', async function (e) {
        e.stopPropagation();
        const resultId = $(this).data('resultId');
        const parentClass = $(this).parent().attr('class');
        if (!parentClass.includes('fallout-history')) {
            await toggleStrikeOutFlag(resultId);
            await falloutDisplayAction(resultId);
        }
    });

    root.find('.flagged-div').off('click').on('click', async function (e) {
        e.stopPropagation();
        const resultId = $(this).data('resultId');
        await toggleFlaggedFlag(resultId);
    });

    root.find('.sticky-div').off('click').on('click', function (e) {
        e.stopPropagation();
        var documentId = $(this).data('documentId');
        editDocNoteFromIcon(documentId);
    });

    root.find('.tag-div').off('click').on('click', function (e) {
        e.stopPropagation();
        var documentId = $(this).data('documentId');
        addDocTags([documentId]);
    });

    root.find('.chain-div').off('click').on('click', async function (e) {
        e.stopPropagation();
        const resultId = $(this).data('resultId');
        await toggleInFinalChainFlag(resultId);
        await falloutDisplayAction(resultId);
    });

    root.find('.watch-div').off('click').on('click', function (e) {
        e.stopPropagation();
        var eventEnabled = $(this).data('eventEnabled');
        var resultId = $(this).data('resultId');
        if (eventEnabled === 1) {
            setOneWatch(resultId);
        }
    });

    root.find('th.sortable').off('click').on('click', changeSorting);

    root.find('.checkbox-cell').off('click').on('click', function (e) {
        e.stopPropagation();
        if (e.target.type !== 'checkbox') {
            $(this).find('input').trigger('click');
        }
    });
}

function changeSorting(event) {
    event.preventDefault();
    var searchTab = $(this).parents('.search-tab');
    var tabButtons = $(this).parent().find('th');

    var urlParameters = {
        orderId: searchTab.data('orderId'),
        searchId: searchTab.data('searchId'),
        sorting: $(this).data('sortKey')
    }

    tabButtons.prop('disabled', true);
    $("body").css("cursor", "wait");
    $.ajax({
        type: 'GET',
        url: '/documents/get-search-page/?' + $.param(urlParameters),
        success: function (response) {
            searchTab.html(response);
            applyTabJavaScript(searchTab);
            loadNextPage(AUTOLOAD_EVENT.TAB_SWITCH);
            $("body").css("cursor", "default");
            tabButtons.prop('disabled', false);
        },
        error: function () {
            console.log('Page Could not be loaded');
            $("body").css("cursor", "default");
            tabButtons.prop('disabled', false);
        }
    });
}


var isMouseDown = false;
var startRowIndex = null;
var startCellIndex = null;

function selectTo(cell) {

    var row = cell.parent();
    var cellIndex = cell.index();
    var rowIndex = row.index();

    var rowStart, rowEnd, cellStart, cellEnd;

    if (rowIndex < startRowIndex) {
        rowStart = rowIndex;
        rowEnd = startRowIndex;
    } else {
        rowStart = startRowIndex;
        rowEnd = rowIndex;
    }

    if (cellIndex < startCellIndex) {
        cellStart = cellIndex;
        cellEnd = startCellIndex;
    } else {
        cellStart = startCellIndex;
        cellEnd = cellIndex;
    }

    for (var i = rowStart; i <= rowEnd; i++) {
        var rowCells = table.find("tr").eq(i).find("td");
        for (var j = cellStart; j <= cellEnd; j++) {
            rowCells.eq(j).addClass("selected");
        }
    }
}

function openWindow(url) {
    return window.open(url, "_blank");
}

function add_row_prototype(row_name, root) {
    // get the div
    var div = root.find("#" + row_name + "_div");

    return addCriteriaRow(div);
}

function addCriteriaRow(prototypeDiv) {
    // get the prototype
    let data = prototypeDiv.data('prototype');
    // get the index
    const index = prototypeDiv.children('div').length;
    // rename all the __name__ instances in prototype to index.
    data = data.replace(/__name__/g, index);
    // insert
    prototypeDiv.append(data);

    // run select2 on all selects
    enableSelect2(prototypeDiv.find(".auto-select-2"), index);
    enableSelect2Tags(prototypeDiv.find('.auto-select-2-tags'));
    enableDictionaryFields(prototypeDiv);

    return prototypeDiv;
}

// This function is called on all pages where you want to display the documents search filter.
// It assumes that there is a search-filter div that has a data-url with the url that contains the
// search filter endpoint.
//
// @params root - this is the tab pane that search filter is displayed on.
// @params callback - a function to be called after the search filter has been fetched and configured
//
// this function most be declared like this to make it accessable to other
// files.   I was getting an undefined error where this function was called.
getSearchFilter = function (root, callback) {
    var url = root.find('#search-filter').data('url');
    // get the data
    $.get(url, function (data) {

        var filter_div = root.find('#search-filter');

        // add the data we got to the div
        filter_div.html(data);

        // set up button listeners

        filter_div.find('#clear_button').on('click', function (event) {
            getSearchFilter(root);
        });

        root.find('#add-recording-info-btn').on('click', function () {
            add_row_prototype('recording_info', root);
        });

        root.find('#add-party-btn').on('click', function () {
            var row = add_row_prototype('party', root);

            var partyInputs = row.find("[class$=phone-book-template]").last();

            partyInputs.find('input').on('keyup', debounce(function (ev) {
                if ((46 <= ev.which && ev.which <= 93) ||
                    ev.which === 8 ||
                    (96 <= ev.which && ev.which <= 106) ||
                    ev.which === 188 ||
                    ev.which === 190 ||
                    ev.which === 32 ||
                    ev.which === 17 ||
                    ev.which === 16
                ) {
                    ev.preventDefault();
                    var data = $(form).serializeArray();
                    searchPhoneBook(data, $(this).parent().parent().parent().parent().parent(), $(this).attr('data'), $(this).attr('id').replace(/(^.+\D)(\d+)(\D.+$)/i, '$2'));
                }
            }, 500));

            partyInputs.find('input:checkbox').on('click', function () {
                var data = $(form).serializeArray();
                nicknameSoundexNoCombo($(this));
                searchPhoneBook(data, $(this).parent().parent().parent().parent().parent(), 'all', $(this).attr('id').replace(/(^.+\D)(\d+)(\D.+$)/i, '$2'));
            });
        });

        root.find('#add-abstract-btn').on('click', function () {
            add_row_prototype('abstract', root);
        });

        root.find('#add-parcel-btn').on('click', function () {
            add_row_prototype('parcel', root);
        });

        root.find('#add-address-btn').on('click', function () {
            add_row_prototype('address', root);
        });

        root.find('.legal-section-add-btn').on('click', function () {

            let prototypeDiv = $(this).parents('.legal-section').find('.legal-prototype');

            addCriteriaRow(prototypeDiv);
        });

        root.find('#add-full-text-legal-btn').on('click', function () {
            add_row_prototype('full-text-legal', root);
        });

        root.find('#add-acreage-btn').on('click', function () {
            var row = add_row_prototype('acreage', root);

            var quarter = row.find("[id$=quarter]").last();
            var table = row.find('table').last();  // maybe search by class instead
            quarter = quarter[0]; // get the first last quarter.
            $(quarter).on('keyup', {grid: table}, fillGridFromString);
            $(table).on('click', 'tbody td', function () {
                if ($(this).hasClass('selected')) {
                    $(this).removeClass('selected');
                } else {
                    $(this).addClass('selected');
                }
                fillStringFromGrid(table, quarter);
            });
        });

        root.find('#add-integrity-legal-btn').on('click', function () {
            var row = add_row_prototype('integrity_legal', root);

            var quarter = row.find("[id$=quarter]").last();
            var table = row.find('table').last();  // maybe search by class instead
            quarter = quarter[0]; // get the first last quarter.
            $(quarter).on('keyup', {grid: table}, fillGridFromString);
        });

        root.find('#add-subdivision-btn').on('click', function () {
            var row = add_row_prototype('subdivision', root);
            row.find('.addition-select').last().on('change', function () {
                linkAdditionToPlatMapButton($(this));
            });
        });

        root.find('#add-market-btn').on('click', function () {
            add_row_prototype('market_source', root);
        });


        var form = root.find('form');

        // run search needs a bit of validation
        root.find(".search-submit-button").on('click', function (ev) {
            ev.preventDefault();

            var data = $(form).serializeArray();
            // gi searches require at least one name entry
            if (validateSearchForm(data)) {
                form.submit();
            }
        });

        // the create order button needs validation
        root.find(".order-create-button").on('click', async function (ev) {
            ev.preventDefault();

            var data = $(form).serializeArray();
            var btn = $(this);


            btn.attr('disabled', 'disabled')
                .children('i')
                .addClass('fa fa-spinner fa-spin')
            ;

            const valid = await validateSearchFormForOrder(data);

            btn.removeAttr('disabled')
                .children('i')
                .removeClass('fa fa-spinner fa-spin')
            ;

            if (!valid) {
                return;
            }

            // this tells the controller that we want to create a new order.
            btn.append('<input id="create_order_hidden" type="hidden" name="documents_search[create_order]" value="1" /> ');
            form.submit();
            btn.find("#create_order_hidden").remove();//if we don't remove this hidden, we can't run search without it creating an order

        });

        root.find(".add-search-to-order-button").on('click', async function (ev) {
            ev.preventDefault();

            const data = $(form).serializeArray();
            const btn = $(this);

            btn.attr('disabled', 'disabled')
                .children('i')
                .addClass('fa fa-spinner fa-spin')
            ;

            const valid = await validateAddressSearchForOrderTab(data);

            btn.removeAttr('disabled')
                .children('i')
                .removeClass('fa fa-spinner fa-spin')
            ;

            if (!valid) {
                return;
            }

            form.submit();
        });


        // enable select2 on all selects and set the maximum number of elements to select
        enableSelect2(form.find('.auto-select-2'), 0);
        enableSelect2Tags(form.find('.auto-select-2-tags'));

        enableDictionaryFields(form);

        // set up the listener for the quarter field/grid
        var quarter = filter_div.find("[id$=quarter]");
        var table = filter_div.find('#land_selection_table');
        $(quarter).on('keyup', {grid: table}, fillGridFromString);
        $(table).on('click', 'td', function () {
            if ($(this).hasClass('selected')) {
                $(this).removeClass('selected');
            } else {
                $(this).addClass('selected');
            }
            fillStringFromGrid(table, quarter);
        });

        // set the z-index on inputs to zero, keeps them from scrolling over
        // other displays on a page
        filter_div.find('input').css('z-index', 0);

        // if call back is a function, call it!
        if (typeof callback === "function")
            callback();

        $('.addition-select').on('change', function () {
            linkAdditionToPlatMapButton($(this));
        });


        var partyInputs = filter_div.find("[class$=phone-book-template]");

        partyInputs.find('input').on('keyup', debounce(function (ev) {
            if ((46 <= ev.which && ev.which <= 93) ||
                ev.which === 8 ||
                (96 <= ev.which && ev.which <= 106) ||
                ev.which === 188 ||
                ev.which === 190 ||
                ev.which === 32 ||
                ev.which === 17 ||
                ev.which === 16
            ) {
                ev.preventDefault();
                var data = $(form).serializeArray();
                searchPhoneBook(data, $(this).parent().parent().parent().parent().parent(), $(this).attr('data'), 0);
            }
        }, 500));

        partyInputs.find('input:checkbox').on('click', function () {
            var data = $(form).serializeArray();
            nicknameSoundexNoCombo($(this));
            searchPhoneBook(data, $(this).parent().parent().parent().parent().parent(), 'all', 0);
        });

    });
};

function nicknameSoundexNoCombo(checkbox) {
    var checkboxId = $(checkbox).attr('id');
    var setUnSet = $('#' + checkboxId).is(":checked");

    if (checkboxId.includes('nicknames') || checkboxId.includes('first_initial')) {
        var otherCheckbox = $('[id$="' + getNumPartyCheckbox(checkboxId) + '_soundex_search"]');
        setCheckboxes(otherCheckbox, setUnSet);
    } else if (checkboxId.includes('soundex')) {
        var nicknameCheckbox = $('[id$="' + getNumPartyCheckbox(checkboxId) + '_use_nicknames"]');
        setCheckboxes(nicknameCheckbox, setUnSet);
        var firstInitialCheckbox = $('[id$="' + getNumPartyCheckbox(checkboxId) + '_use_first_initial"]');
        setCheckboxes(firstInitialCheckbox, setUnSet);
    }
}

function setCheckboxes(checkbox, setOrUnset) {
    if (setOrUnset) {
        if (checkbox.is(":checked")) {
            checkbox.prop('checked', false);
        }
        checkbox.prop('disabled', true);
        checkbox.addClass('text-muted');
        checkbox.parent().addClass('text-muted');
    } else {
        checkbox.prop('disabled', false);
        checkbox.removeClass('text-muted');
        checkbox.parent().removeClass('text-muted');
    }
}

function getNumPartyCheckbox(id) {
    return parseInt(id.match(/\d+/)[0]);
}

function searchPhoneBook(data, parent, type, partyIndex) {
    for (let nameType of getTypeArray(type)) {
        reloadPhoneBook(parent, nameType, partyIndex);
        const party = checkInputsForPhoneBook(parent, nameType, {
            grantee_name: '', grantor_name: '', party_name: '',
            proximity_search: '0', use_nicknames: '0', use_first_initial: '0', soundex_search: '0'
        });
        if (!party) {
            parent.find('#loading_spinner_' + nameType).hide();
            continue;
        }

        const searchId = getSelectedSearchId();

        phoneBookXHR[partyIndex][nameType] = $.ajax({
            type: 'POST',
            url: '/phone-book/' + $('#search-filter-plant-id').val(),
            data: {
                party: party,
                searchId: searchId
            },
            success: function (response) {
                updatePhoneBook(response, parent, nameType);
            }
        });
    }
}

function getTypeArray(type) {
    if (type === 'all') {
        // we pass in 'all' if the user clicks a checkbox. We want to reload all 3 types.
        return ['grantor', 'grantee', 'party'];
    }

    return [type];
}

function checkInputsForPhoneBook(parent, type, list) {
    const input = parent.find("[id$=" + type + "_name]");
    if (input.val() === '') {
        return false;
    }

    list[type + '_name'] = input.val();
    list.proximity_search = parent.find("[id$=proximity_search]").is(':checked') ? '1' : '0';
    list.use_nicknames = parent.find("[id$=use_nicknames]").is(':checked') ? '1' : '0';
    list.use_first_initial = parent.find("[id$=use_first_initial]").is(':checked') ? '1' : '0';
    list.soundex_search = parent.find("[id$=soundex_search]").is(':checked') ? '1' : '0';
    return list;
}

function reloadPhoneBook(parent, type, partyIndex) {
    resetAllDivsAndCounts(parent, type);
    hideNarrowSearchMessage(parent, type);
    if (partyIndex in phoneBookXHR) {
        if (phoneBookXHR[partyIndex][type] && phoneBookXHR[partyIndex][type].readyState !== 4) {
            phoneBookXHR[partyIndex][type].abort();
        }
    } else {
        phoneBookXHR[partyIndex] = {
            grantor: false,
            grantee: false,
            party: false
        };
    }
}

function resetAllDivsAndCounts(parent, type) {
    parent.find('#phone_book_' + type).empty();
    parent.find('#phone_book_' + type + '_selected').empty();
    parent.find('#phone_book_' + type + '_count').text('');
    parent.find('#phone_book_' + type + '_selected_count').text('');
    parent.find('#loading_spinner_' + type).show();
    setPhoneBookNameJson(parent, [], type);
}

function updatePhoneBook(names, parent, type) {
    const canClick = setResultCount(parent, type, names.length);
    if (names.length === 0) {
        return;
    }

    const phoneBookResults = parent.find('#phone_book_' + type);
    addNamesToPhoneBook(names, phoneBookResults);
    if (canClick) {
        hideNarrowSearchMessage(parent, type);
        changeSearchingNamesText(parent, type, 0);
        addListenersToPhoneBookResults(phoneBookResults, parent, type);
    } else {
        showNarrowSearchMessage(parent, type)
    }
}

function showNarrowSearchMessage(parent, type) {
    parent.find('#narrow_search_' + type).show();
    parent.find('#phone_book_' + type).find('.name-option').removeClass('name-option-hover');
}

function hideNarrowSearchMessage(parent, type) {
    parent.find('#narrow_search_' + type).hide();
    parent.find('#phone_book_' + type).find('.name-option').addClass('name-option-hover');
}

function addListenersToPhoneBookResults(phoneBookResults, parent, type) {
    const phoneBookSelected = parent.find('#phone_book_' + type + '_selected');
    const typePhoneBookJson = getPhoneBookNameJson(parent, type);

    //make sure we don't already have any listeners
    phoneBookResults.find('.name-option').unbind('click');
    phoneBookResults.find('.name-option').on('click', function () {
        const name = $(this).text();
        if (!findNameInJson(name, type, typePhoneBookJson)) {
            selectAName(name, parent, type, typePhoneBookJson, phoneBookSelected);
            setPhoneBookNameJson(parent, typePhoneBookJson, type);
            $(this).remove();
            setResultCount(parent, type, phoneBookResults.find('.name-option').length);
        }
    });
}

function selectAName(name, parent, type, typePhoneBookJson, phoneBookSelected) {
    typePhoneBookJson.push(name);
    changeSearchingNamesText(parent, type, typePhoneBookJson.length);
    phoneBookSelected.append('<div class="name-option selected-option name-option-hover">' + name + '</div>');

    // have to unbind so we don't add multiple listeners to the same element
    phoneBookSelected.find('.selected-option').unbind('click');
    addListenersToSelectedNames(parent, type, phoneBookSelected, typePhoneBookJson);
}

function addListenersToSelectedNames(parent, type, phoneBookSelected, typePhoneBookJson) {
    phoneBookSelected.find('.selected-option').on('click', function () {
        typePhoneBookJson.splice(typePhoneBookJson.indexOf($(this).text()), 1);
        changeSearchingNamesText(parent, type, typePhoneBookJson.length);
        $(this).remove();
        setPhoneBookNameJson(parent, typePhoneBookJson, type);
        addBackToPhoneBookResults(parent, type, $(this).text());
    });
}

function addBackToPhoneBookResults(parent, type, name) {
    const phoneBookResults = parent.find('#phone_book_' + type);
    phoneBookResults.append('<div value="' + name + '" class="name-option name-option-hover">' + name + '</div>');
    phoneBookResults.find('.name-option').sort(asc_sort).appendTo(phoneBookResults);
    addListenersToPhoneBookResults(phoneBookResults, parent, type);
    setResultCount(parent, type, phoneBookResults.find('.name-option').length);
}

function asc_sort(a, b) {
    return ($(b).text()) < ($(a).text()) ? 1 : -1;
}

function addNamesToPhoneBook(names, phoneBookResults) {
    for (let i = 0; i < names.length; i++) {
        phoneBookResults.append('<div value="' + names[i] + '" class="name-option name-option-hover">' + names[i] + '</div>');
    }
}

function setResultCount(parent, type, count) {
    parent.find('#loading_spinner_' + type).hide();
    parent.find('#phone_book_' + type + '_count').text(count + (count === 500 ? '+ results found' : ' results found'));

    return count < 500;
}

function changeSearchingNamesText(parent, type, number) {
    number = number === 0 ? 'all' : number;
    parent.find('#phone_book_' + type + '_selected_count').text('Searching ' + number + (number === 1 ? ' name' : ' names'));
}

function findNameInJson(name, type, typePhoneBookJson) {
    return typePhoneBookJson.find((item) => {
        return item === name;
    });
}

function getPhoneBookNameJson(parent, type) {
    return JSON.parse(parent.find('[id$=phone_book_names]').val())[type + '_names'];
}

function setPhoneBookNameJson(parent, value, type) {
    let json = JSON.parse(parent.find('[id$=phone_book_names]').val());
    json[type + '_names'] = value;
    parent.find('[id$=phone_book_names]').val(JSON.stringify(json));
}

function linkAdditionToPlatMapButton(additionButton) {
    var plantId = $('#search-filter-plant-id').val();
    var addition = additionButton.find('option:selected').val();
    var link = additionButton.parents('.subdivision-subsection').find('.btn-plat-map-link');
    var linkRow = link.parents('.plat-map-link-row');

    if (addition == '' || addition === undefined) {
        linkRow.addClass('collapse');
    } else {
        var baseUrl = link.data('baseUrl');
        var textAddition = addition;
        if (addition.length > 40) {
            textAddition = addition.substr(0, 10) + '...' + addition.substr(-10);
        }
        link.text(textAddition + ' Plat Info');
        link.attr("data-toggle", 'tooltip');
        link.attr("title", addition);
        link.attr("href", baseUrl + plantId + '/plat-maps?addition=' + encodeURIComponent(addition));
        linkRow.removeClass('collapse');
    }
}

function validateSearchForm(data) {
    let msg = "";
    // if (validate_array(data, 'gi_only') && !validate_array(data, 'parties')) {
    //     msg += "GI only search requires at least one party entry.\n";
    // }

    if (!validateSearchEntries(data)) {
        msg += "Please enter at least one value to run search\n";
    }

    // abstract legal form validation is completely taken care of by legalTypes
    const legalTypes = $('#legal-types').data('legalTypes');

    if (legalTypes !== null && legalTypes.length > 0) {
        legalTypes.forEach((legalType) => {
            if (!validateLegalSection(data, legalType)) {
                msg += legalType['formValidationMessage'];
            }
        })

        if ("" !== msg) {
            alert(msg);
            return false;
        }

        return true;
    }

    const isIntegrity = isPlantAbstract(data, '[integrity_nm_legals]');

    if (isIntegrity) {
        if (!validateSectionAndQuarterEntries(data)) {
            msg += "Please enter quarter with section into legal\n";
        }

        if (!validateAcreageWithAddition(data)) {
            msg += "Please enter either addition or acreage legal\n";
        }
    }

    if (!isIntegrity && !validateAcreageEntries(data)) {
        msg += "Please enter either a comment alone or a section, township, and range together into acreage\n";
    }

    const isEstate = isPlantAbstract(data, '[estateLegals]');
    const isCondo = isPlantAbstract(data, '[condoLegals]');

    if (isCondo && !validateCondoEntries(data)) {
        msg += "Please enter at least condo into the condo legals section.\n";
    }

    if (isEstate && !validateEstateEntries(data)) {
        msg += "Please enter at least estate into the estate legals section.\n";
    }

    const miningClaimsEnabled = $('.mining-claims-enabled').length > 0;
    const subPidEnabled = $('.sub-pid-enabled').length > 0;
    const subBookEnabled = $('.sub-book-enabled').length > 0;
    const subPageEnabled = $('.sub-page-enabled').length > 0;

    if (!isIntegrity && !validateSubdivisions(data)) {
        if (miningClaimsEnabled) {
            msg += "Please enter a value in the addition, comment, claim, or mining survey field for the subdivision section\n";
        }  else if (subPidEnabled && subBookEnabled && subPageEnabled) {
            msg += "Please enter a value in the addition, comment, PID, or book and page field for the subdivision section.\n";
        } else {
            msg += "Please enter a value in the addition or comment field for the subdivision section\n";
        }
    }

    if ("" !== msg) {
        alert(msg);
        return false;
    }

    return true;
}

function validateLegalSection(data, legalType) {
    const numOfSubdivisionSections = getNumSections(data, legalType['criteriaKey']);
    const validationKeyArrays = legalType['formValidationKeys'];
    let valid = true;

    for (i = 0; i < numOfSubdivisionSections + 1; i++) {
        if (validate_multiSectionArray(data, legalType['criteriaKey'], i)) {
            for (let z = 0; z < validationKeyArrays.length; z++) {
                const requiredKeys = validationKeyArrays[z];
                valid = true;

                for (let k = 0; k < requiredKeys.length; k++) {
                    if (!validate_multiSectionSubdivisionArray(data, requiredKeys[k], i)) {
                        valid = false;
                    }
                }

                // if all required fields in one of the arrays are valid, the section is valid
                if (valid === true) {
                    return valid;
                }
            }
        }
    }

    return valid;
}

function validateSubdivisions(data) {
    var numOfSubdivisionSections = getNumSections(data, 'subdivisions');

    for (i = 0; i < numOfSubdivisionSections + 1; i++) {
        if (validate_multiSectionArray(data, 'subdivisions', i)) {
            if (!validate_multiSectionSubdivisionArray(data, 'addition', i) &&
                !validate_multiSectionSubdivisionArray(data, 'claim', i) &&
                !validate_multiSectionSubdivisionArray(data, 'miningSurvey', i) &&
                !validate_multiSectionSubdivisionArray(data, 'p_i_d', i) &&
                (!validate_multiSectionSubdivisionArray(data, 'book', i) || !validate_multiSectionSubdivisionArray(data, 'page', i)) &&
                !validate_multiSectionSubdivisionArray(data, 'subdivision_comment', i)) {
                return false;
            }
        }
    }
    return true;
}

function validateSearchEntries(data) {
    for (i = 0; i < data.length; i++) {
        if (data[i].name.search('query_before') >= 0 ||
            data[i].name.search('_token') >= 0 ||
            data[i].name.search('soundex_search') >= 0 ||
            data[i].name.search('use_nicknames') >= 0 ||
            data[i].name.search('use_first_initial') >= 0 ||
            data[i].name.search('proximity_search') >= 0 ||
            data[i].name.search('exclude_related_documents') >= 0 ||
            data[i].name.search('exact_legal_searches') >= 0 ||
            data[i].name.search('enable_query_before') >= 0 ||
            data[i].name.search('phone_book_names') >= 0 ||
            data[i].name.search('criteria') >= 0 ||
            data[i].name.search('exclude_orders_starters') >= 0 ||
            data[i].name.search('mineral_search') >= 0) {
            continue;
        }
        if (data[i].value.length > 0) {
            return true;
        }
    }
    return false;
}

function validateAcreageEntries(data) {
    var numOfAcreageSections = getNumSections(data, 'acreages');

    for (i = 0; i < numOfAcreageSections + 1; i++) {
        if (validate_multiSectionArray(data, 'acreages', i)) {
            var hasComment = false;
            var hasSection = false;
            var hasTownship = false;
            var hasRange = false;
            var hasOtherValue = false;
            for (j = 0; j < data.length; j++) {
                if (data[j].name.includes('[acreages][' + i + ']')) {
                    if (data[j].name.search('acreage_comment') >= 0 && data[j].value.length !== 0) {
                        hasComment = true;
                        continue;
                    }
                    if (data[j].name.search('section') >= 0 && data[j].value.length !== 0) {
                        hasSection = true;
                        hasOtherValue = true;
                        continue;
                    }
                    if (data[j].name.search('township') >= 0 && data[j].value.length !== 0) {
                        hasTownship = true;
                        hasOtherValue = true;
                        continue;
                    }
                    if (data[j].name.search('range') >= 0 && data[j].value.length !== 0) {
                        hasRange = true;
                        hasOtherValue = true;
                        continue;
                    }
                    if (data[j].value.length !== 0) {
                        hasOtherValue = true;
                    }
                }
            }
            var hasStandardCriteria = (hasSection && hasTownship && hasRange);
            if ((!hasStandardCriteria && !hasComment) || (hasComment && hasOtherValue && !hasStandardCriteria)) {
                return false;
            }
        }
    }

    return true;
}

function validateSectionAndQuarterEntries(data) {
    var numOfLegalSections = getNumSections(data, 'integrity_nm_legals');

    for (i = 0; i < numOfLegalSections + 1; i++) {
        if (validate_multiSectionArray(data, 'integrity_nm_legals', i)) {
            if (validate_multiSectionSubdivisionArray(data, 'section', i) &&
                (
                    !validate_multiSectionSubdivisionArray(data, 'quarter', i) ||
                    !validate_multiSectionSubdivisionArray(data, 'section', i)
                )) {
                return false;
            }
        }
    }
    return true;
}

function validateAcreageWithAddition(data) {
    var numOfLegalSections = getNumSections(data, 'integrity_nm_legals');

    for (i = 0; i < numOfLegalSections + 1; i++) {
        if (validate_multiSectionArray(data, 'integrity_nm_legals', i)) {
            if (validate_multiSectionSubdivisionArray(data, 'addition', i) &&
                (
                    validate_multiSectionSubdivisionArray(data, 'quarter', i) ||
                    validate_multiSectionSubdivisionArray(data, 'section', i) ||
                    validate_multiSectionSubdivisionArray(data, 'township', i) ||
                    validate_multiSectionSubdivisionArray(data, 'range', i) ||
                    validate_multiSectionSubdivisionArray(data, 'govLot', i)
                )) {
                return false;
            }
        }
    }
    return true;
}

function validateCondoEntries(data) {
    const numOfAbstractSections = getNumSections(data, 'condoLegals');

    for (let i = 0; i < numOfAbstractSections + 1; i++) {
        if (validate_multiSectionArray(data, 'condoLegals', i)) {
            if (
                !validate_multiSectionSubdivisionArray(data, 'condo', i)
            ) {
                return false;
            }
        }
    }
    return true;
}

function validateEstateEntries(data) {
    const numOfAbstractSections = getNumSections(data, 'estateLegals');

    for (let i = 0; i < numOfAbstractSections + 1; i++) {
        if (validate_multiSectionArray(data, 'estateLegals', i)) {
            if (
                !validate_multiSectionSubdivisionArray(data, 'estate', i)
            ) {
                return false;
            }
        }
    }
    return true;
}

function isPlantAbstract(data, searchString) {
    for (i = 0; i < data.length; i++) {
        if (data[i].name.includes(searchString)) {
            return true;
        }
    }
    return false;
}

function validate_multiSectionArray(data, search_term, index) {
    for (z = 0; z < data.length; z++) {
        //we never want to validate if only the orNull checkbox is set to true
        if (data[z].name.includes('or_null][orNull]')) {
            continue;
        }
        if (data[z].name.includes('mineral_search')) {
            continue;
        }
        if (data[z].name.includes('[' + search_term + '][' + index + ']') && data[z].value.length > 0) {
            return true;
        }
    }
    return false;
}

function validate_multiSectionSubdivisionArray(data, search_term, index) {
    for (z = 0; z < data.length; z++) {
        if (data[z].name.includes('[' + index + '][' + search_term + ']') && data[z].value.length > 0) {
            return true;
        }
    }
    return false;
}

function getNumSections(data, search_term) {
    var arrayOfNums = [];
    for (i = 0; i < data.length; i++) {
        if (data[i].name.search(search_term) >= 0) {
            arrayOfNums.push(parseInt(data[i].name.match(/\d+/)[0]));
        }
    }
    return Math.max(...arrayOfNums);
}


// validates a search form.   In this case we want one
// name field to have a value and one of the land fields to have a value
//
// the data comes in the form of an array with elements { name: "documents_search[parties|acreages|etc]", value: "some value" }
function getPlantId() {
    return $("#plant-id").val();
}

function getPlantUuid() {
    return $("#plant-uuid").val();
}

async function validateAddressSearchForOrderTab(data)
{
    const numOfSections = getNumSections(data, 'addresses');

    for (i = 0; i < numOfSections + 1; i++) {
        if (validate_multiSectionSubdivisionArray(data, 'address', i) ||
            validate_multiSectionSubdivisionArray(data, 'city', i) ||
            validate_multiSectionSubdivisionArray(data, 'state', i) ||
            validate_multiSectionSubdivisionArray(data, 'zip_code', i)) {
            return true;
        }
    }

    alert("At least one address field must have a value.\n");
    return false;
}

// we just search the array of data for parties, subdivisions, or acreages and then check the value to see if it is non null.
async function validateSearchFormForOrder(data) {

    let msg = "";

    if (hasValueSetInArray(data, 'recording_infos', 'date_to') > 0) {
        msg += "Date To is not allowed when creating an order. Please clear it.\n";
    }

    if (!validateParties(data, 'parties')) {
        msg += "Please enter a value for at least one of the name fields.\n";
    }

    var orderName = arrayGet(data, 'order_name');
    if (!orderName.length) {
        msg += "Please enter an order name.\n";
    }

    if (orderName) {
        const plantId = getPlantId();
        let orderNameUnique = false;
        try {
            await $.ajax({
                type: 'POST',
                url: `/api/plants/${plantId}/validate-order-name`,
                data: {
                    name: arrayGet(data, 'order_name')
                }
            });
            orderNameUnique = true
        } catch (e) {

        }

        if (!orderNameUnique) {
            msg += "This order name already exists. Please enter a unique order name.\n";
        }

    }

    // abstract legal form validation is completely taken care of by legalTypes
    const legalTypes = $('#legal-types').data('legalTypes');

    if (legalTypes !== null && legalTypes.length > 0) {
        let emptyLegalTypes = true;

        legalTypes.forEach((legalType) => {
            if (validate_array(data, legalType['criteriaKey'])) {
                emptyLegalTypes = false
            }
        })

        if (emptyLegalTypes) {
            msg += "Please fill at least one legal section\n";
        }

        legalTypes.forEach((legalType) => {
            if (!validateLegalSection(data, legalType)) {
                msg += legalType['formValidationMessage'];
            }
        })

        if ("" !== msg) {
            alert(msg);
            return false;
        }

        return true;
    }

    const isIntegrity = isPlantAbstract(data, '[integrity_nm_legals]');

    if (isIntegrity) {
        if (!validateSectionAndQuarterEntries(data)) {
            msg += "Please enter quarter with section into legal\n";
        }

        if (!validateAcreageWithAddition(data)) {
            msg += "Please enter either addition or acreage legal\n";
        }
    }

    const miningClaimsEnabled = $('.mining-claims-enabled').length > 0;
    const subPidEnabled = $('.sub-pid-enabled').length > 0;
    const subBookEnabled = $('.sub-book-enabled').length > 0;
    const subPageEnabled = $('.sub-page-enabled').length > 0;

    if (!isIntegrity && !validateSubdivisions(data)) {
        if (miningClaimsEnabled) {
            msg += "Please enter a value in the addition, comment, claim, or mining survey field for the subdivision section.\n";
        } else if (subPidEnabled && subBookEnabled && subPageEnabled) {
            msg += "Please enter a value in the addition, comment, PID, or book and page field for the subdivision section.\n";
        } else {
            msg += "Please enter a value in the addition or comment field for the subdivision section.\n";
        }
    }

    if (!isIntegrity && !validateAcreageEntries(data)) {
        msg += "Please enter a comment alone or section, township, and range together into acreage.\n";
    }

    const isEstate = isPlantAbstract(data, '[estateLegals]');
    const isCondo = isPlantAbstract(data, '[condoLegals]');

    if (isEstate && isCondo) {
        if (!validate_array(data, 'estateLegals')
            && !validate_array(data, 'condoLegals')
        ) {
            msg += "Please fill at least one legal section\n";
        }
    } else if (!validate_array(data, 'acreages')
        && !validate_array(data, 'subdivisions')
        && !validate_array(data, 'abstracts')
        && !validate_array(data, 'integrity_nm_legals')) {
        msg += "Please fill at least one of the subdivision, acreage, or abstract sections.\n";
    }

    if (isCondo && !validateCondoEntries(data)) {
        msg += "Please enter at least condo into the condo legals section.\n";
    }

    if (isEstate && !validateEstateEntries(data)) {
        msg += "Please enter at least estate into the estate legals section.\n";
    }

    if ("" !== msg) {
        alert(msg);
        return false;
    }

    return true;
}

function updateRunFallout(search_id, value) {
    var dataString = "searchId=" + search_id + "&value=" + value;
    $.ajax({
        type: 'GET',
        url: '/searches/changeRunFallout',
        data: dataString,
        success: function (response) {
        },
        error: function (response) {
            alert('there was an error with the post ' + response);
        }
    });
}

function validateParties(data) {
    for (i = 0; i < data.length; i++) {
        if (data[i].name.search('grantee_name') >= 0 && data[i].value.length > 0) {
            return true;
        }
        if (data[i].name.search('grantor_name') >= 0 && data[i].value.length > 0) {
            return true;
        }
        if (data[i].name.search('party_name') >= 0 && data[i].value.length > 0) {
            return true;
        }
    }
}

function validate_array(data, search_term) {
    for (i = 0; i < data.length; i++) {
        // mineral search is set to NO by default so we need to ignore it
        if (data[i].name.search('mineral_search') >= 0 && data[i].value.length > 0) {
            continue;
        }
        if (data[i].name.search(search_term) >= 0 && data[i].value.length > 0) {
            return true;
        }
    }

    return false;
}

function arrayGet(data, searchTerm) {
    for (i = 0; i < data.length; i++) {
        if (data[i].name.search(searchTerm) >= 0) {
            return data[i].value;
        }
    }

    return null;
}

function hasValueSetInArray(data, arrayKey, childKey) {
    for (let i = 0; i < data.length; i++) {
        const name = data[i].name;
        const arrayNamePosition = name.search(arrayKey);
        if (arrayNamePosition >= 0 && name.search(childKey) >= arrayNamePosition) {
            let value = data[i].value;
            if (value != null && value.length > 0) {
                return true;
            }
        }
    }

    return false;
}


// used to hide or display the search filter.
// root is the tab pane the search filter is displayed on
function toggleSearchFilter(root) {
    var button = root.find('#display_search_filter_toggle');
    var search_filter = root.find('#search-filter');

    if (button.html().indexOf("Display") >= 0) {
        $(button).html("Loading Search Filter");
        getSearchFilter(root, function () {
            $(button).html("Hide Search Filter");
        });

    } else { //hide
        $(button).html("Display Search Filter");
        $(search_filter).html("");
    }
}


// toggle hiding the rest of the search form if this is a gi only search
function toggleGIOnly(searchForm, giOnlyCheckbox) {
    var is_checked = $(giOnlyCheckbox)[0].checked;
    var acreageSection = searchForm.find('.acreage-section');
    var subdivisionSection = searchForm.find('.subdivision-section');

    if (is_checked) { // hide everything
        $(acreageSection).hide();
        $(subdivisionSection).hide();

        // clear everything
        $(acreageSection).find('input').val("");
        $(acreageSection).find('[id$=quarter]').trigger('keyup');
        $(subdivisionSection).find('input').val("");
        $(subdivisionSection).find('select').val("");

    } else { // reveal everything
        $(acreageSection).show();
        $(subdivisionSection).show();
    }
}

function addRemoveFromFinalChain(possible_document_id, parentClass) {

    var finalTabId = $('#final-id').val();

    var selectedTabId = getSelectedSearchId();

    var selectedDocuments = getSelectedDocs();

    var allAreChecked = true;
    var selectedDocumentIds = [];
    if (selectedTabId === 0) {
        selectedDocumentIds.push(possible_document_id);
        if (!$('#document_' + possible_document_id).find('.chain-div').data('chain')) {
            allAreChecked = false;
        }
    } else {
        if (possible_document_id !== '') {
            selectedDocuments = $('#searching-tab-' + selectedTabId).find('#selected_' + possible_document_id);
        }

        selectedDocuments.each(function () {
            if (!$(this).parent().parent().find('.chain-div').data('chain')) {
                allAreChecked = false;
            }
            selectedDocumentIds.push($(this).val());
        });
    }

    var shouldRemove = allAreChecked;

    if (selectedDocumentIds.length < 1) {
        return;
    }

    var checkForValidation = false;
    if (selectedTabId == 0) {
        selectedTabId = falloutWorkForFinalChain(possible_document_id);
        var resultId = $('#document_' + possible_document_id).attr('data-result-id');
        if ($('#searching-tab-0').find('#document-table').find('#' + resultId + '-details').is(':visible')) {
            expandDetails(resultId, parentClass);
        }
        checkForValidation = true;
    }

    var dataString = 'data=' + JSON.stringify({
        document_ids: selectedDocumentIds,
        search_id: selectedTabId,
        order_id: getOrderId()
    });
    //console.log(getOrderId());
    // On final chain. Deleting

    if (finalTabId === selectedTabId) {
        shouldRemove = true;
    }

    if (shouldRemove) {
        $.ajax({
            type: 'POST',
            url: '/order/removeFromFinalChain/',
            data: dataString,
            success: function () {
                selectedDocuments.removeClass('in-final-chain');
                reloadSearchTab(finalTabId, window);
            },
            error: function (response) {
                alert('there was an error with the post ' + response);
            }
        });

        // set all the removed documents to 0
        selectedDocuments.each(function () {
            // find all check boxes with the given doc id
            var selected = $('.search-tab').find('#selected_' + $(this).val());
            // for each box, set the chain notification to zero
            selected.each(function () {
                setNotificationDisplay($(this).parent().parent(), 'chain', 0);
                if ($(this).parent().parent()[0].className.includes('fallout_reveal')) {
                    checkChainNotificationForFalloutHistory(possible_document_id);
                }
            });
        });

        // Not on final chain. Adding
    } else {

        $.ajax({
            type: 'POST',
            url: '/order/addToFinalChain/',
            data: dataString,
            success: function () {
                selectedDocuments.addClass('in-final-chain');
                if (checkForValidation) {
                    checkIfWatchIsValidated(getOrderId(), possible_document_id);
                }
                reloadSearchTab(finalTabId, window);
            },
            error: function (response) {
                alert('there was an error with the post ' + response);
            }
        });
        // set all the added documents to 1
        selectedDocuments.each(function () {
            setNotificationDisplay($(this).parent().parent(), 'chain', 1);
            if ($(this).parent().parent()[0].className.includes('fallout_reveal')) {
                checkChainNotificationForFalloutHistory(possible_document_id);
            }
        });
    }

    unselectAll();
}


function checkChainNotificationForFalloutHistory(documentId) {
    $('.fallout-history').each(function () {
        if ($(this).attr('id').includes(documentId)) {
            setNotificationDisplay($(this), 'chain', ($(this).find('.chain-div').data('chain') + 1) % 2);
        }
    });
}

function falloutToggleChain(resultId) {
    var selectedTab = 0;
    $('tr[data-result-id="' + resultId + '"]').each(function () {
        setNotificationDisplay($(this), 'chain', ($(this).find('.chain-div').data('chain') + 1) % 2);
        if ($(this).data('searchId') != 0) {
            selectedTab = $(this).data('searchId');
        }
    });
    return selectedTab;

    // if (selectedDocumentIds.length < 1) {
    //     return;
    // }
    //
    // var dataString = 'data=' + JSON.stringify({
    //         document_ids: selectedDocumentIds,
    //         search_id: selectedTabId,
    //         order_id: getOrderId()
    //     });
    // //console.log(getOrderId());
    // // On final chain. Deleting
    // if (finalTabId === selectedTabId) {
    //
    //     $.ajax({
    //         type: 'POST',
    //         url: '/order/removeFromFinalChain/',
    //         data: dataString,
    //         success: function () {
    //             selectedDocuments.removeClass('in-final-chain');
    //             reloadSearchTab(finalTabId, window);
    //         },
    //         error: function (response) {
    //             alert('there was an error with the post ' + response);
    //         }
    //     });
    //
    //     // set all the removed documents to 0
    //     selectedDocuments.each(function () {
    //         // find all check boxes with the given doc id
    //         var selected = $('.search-tab').find('#selected_' + $(this).val());
    //         // for each box, set the chain notification to zero
    //         selected.each(function () {
    //             setNotificationDisplay($(this).parent().parent().find('.notification-td'), 'chain', 0);
    //         });
    //
    //     });
    //
    //     // Not on final chain. Adding
    // } else {
    //
    //     $.ajax({
    //         type: 'POST',
    //         url: '/order/addToFinalChain/',
    //         data: dataString,
    //         success: function () {
    //             selectedDocuments.addClass('in-final-chain');
    //             reloadSearchTab(finalTabId, window);
    //         },
    //         error: function (response) {
    //             alert('there was an error with the post ' + response);
    //         }
    //     });
    //     // set all the added documents to 1
    //     selectedDocuments.each(function () {
    //         setNotificationDisplay($(this).parent().parent().find('.notification-td'), 'chain', 1);
    //     });
    // }
    //
    // unselectAll();
}


function addRemoveSingleDocumentFromFinalChain(document_id, order_id, is_in_final_chain, root) {
    var finalTabId = root.$('#myTab').find('li.final-chain a').data('searchId');
    // when the search page is reloaded, the link's final-chain is not updated
    // if so, the above jqeury would fail. So, if that is the case, we
    // get the search id of the last tab and set the final-chain class
    if (finalTabId === null) {
        finalTabId = root.$('#myTab').find('li:last a').data('searchId');
        root.$('#myTab').find('li:last').addClass('final-chain');
    }

    var searchId = $('#search-id').val();

    var selectedDocumentIds = [];

    selectedDocumentIds.push(document_id);

    var dataString = 'data=' + JSON.stringify({
        document_ids: selectedDocumentIds,
        search_id: searchId,
        order_id: order_id
    });

    if (is_in_final_chain) {
        //console.log("removing");
        $.ajax({
            type: 'POST',
            url: '/order/removeFromFinalChain/',
            data: dataString,
            success: function () {
                reloadSearchTab(finalTabId, root);
            },
            error: function (response) {
                alert('there was an error with the post ' + response);
            }
        });

        // Not on final chain. Adding
    } else {
        //console.log("adding");
        $.ajax({
            type: 'POST',
            url: '/order/addToFinalChain/',
            data: dataString,
            success: function () {
                reloadSearchTab(finalTabId, root);
            },
            error: function (response) {
                alert('there was an error with the post ' + response);
            }
        });
    }

}

/**
 * Go through a few checks before saving the selection. If all is good, show the modal.
 */
function saveChainChecklist() {

    if (!$('.search-tab').find('.selected:checked').length) {
        // No documents selected
        showError(errors.empty_selection);

    } else if ($('#search-id').val() === 0) {
        // Search has not been saved yet, nothing to attach the selection to
        showError(errors.save_selection);

    } else {

        var doc_ids = [];
        $('.search-tab').find('.selected:checked').each(function () {
            doc_ids.push($(this).val());
        });
        displaySaveChainModal(doc_ids, $('#order-id').val(), false);

    }
}

function saveSearch() {
    hideError();

    var searchId = getSelectedSearchId();
    var orderId = getOrderId();

    var searchedDocuments = {
        'search_title': $('#order_type_' + searchId + '_search_title').val(),
        'search_notes': $('#order_type_' + searchId + '_search_notes').val(),
        'order_title': $('#order_type_' + searchId + '_order_title').val(),
        'order_notes': $('#order_type_' + searchId + '_order_notes').val(),
        'create_order': $('#order_type_' + searchId + '_create_order').val(),
        'order_choice': $('#order_type_' + searchId + '_existing_order').val(),
        'search_id': searchId,
        'order_id': orderId
    };

    $.ajax({
        type: 'POST',
        url: '/searches/save/',
        data: {data: searchedDocuments},
        success: function (response) {
            var parsedResponse = JSON.parse(response);
            window.location.href = '/documents/?orderId=' + parsedResponse['order_id'];
        },
        error: function () {
            alert('Error while saving search');
        }
    });
}


function displaySaveChainModal(doc_ids, order_id, is_child_tab) {
    // grab the data from the controller
    var dataString = '?document_ids=' + JSON.stringify(doc_ids) + '&order_id=' + order_id;

    $.get('/searches/saveChain/' + dataString, function (data) {
        $('#save_chain_modal_display').html(data);
        $('#myModal').modal('show');
        setupModalSubmit(dataString, is_child_tab);
    });
}

function setupModalSubmit(dataString, is_child_tab) {
    $("#myModal form").submit(function (event) {
        // prevent the default submit from happening
        event.preventDefault();

        var data = $(this).serialize();

        // post a response to the controller, but capture its output.  Don't redirect!
        $.post('/searches/saveChain/' + dataString, data, function (response) {

            $('#myModal').modal('hide');
            var parsedResponse = JSON.parse(response);

            var selector = (is_child_tab) ? window.opener.$('#saved-selection option:last') : $('#saved-selection option:last');

            $(selector).after(
                '<option value="' + parsedResponse['selection_id'] + '">' + parsedResponse['selection_name'] + "</option>"
            );

            if (!is_child_tab) {
                //load up that selection in another tab//
                loadChain(parsedResponse['selection_id']);

                //clear the unsaved tab//
                clearUnsavedSelectionTab();
            }

        });
    });
}

// prepare all the data necessary to call the save search
function prepareSaveSearch() {
    // what do I need?// get the data for the request: need search id, order id, document_ids, the criteria, the sorting,
    var search_id = getSelectedSearchId();

    var order_id = $('#order-id').val();
    if (order_id === "undefined")
        order_id = 0;

    var doc_ids = [];
    $('.search-tab').find('.selected').each(function () {
        doc_ids.push($(this).val());
    });

    var criteria = $('#criteria-' + search_id).val();
    var sorting = $('#sorting-' + search_id).val();

    displaySaveSearchModal(search_id, order_id, doc_ids, criteria, sorting);
}


function displayDocument(documentId, orderId, searchId) {
    window.open('/documents/displayPdf/?documentId=' + documentId + '&orderId=' + orderId + '&searchId=' + searchId, '_blank');
}


// creates a data string given the parameters and then calls get to get the data from the controller
function displaySaveSearchModal(search_id, order_id, doc_ids, criteria, sorting) {
    if (typeof order_id === "undefined") {
        console.log("order_id is undefined, exiting");
        return;
    }

    // grab the data from the controller
    var dataString = '?search_id=' + search_id + '&order_id=' + order_id + '&document_ids=' + JSON.stringify(doc_ids)
        + '&criteria=' + criteria + '&sorting=' + sorting;

    $.get('/searches/saveSearch/' + dataString, function (data) {
        $('#save_search_modal_display').html(data); // display the data
        $('#saveSearch').modal('show'); // show the modal
        setupSaveModalSubmit(dataString); // set up the sumbit to use ajax
    });
}

// sets up the submit button on the modal to use ajax to communicate with the controller.
function setupSaveModalSubmit(dataString) {

    $("#saveSearch form").submit(function (event) {
        // prevent the default submit from happening
        event.preventDefault();

        var data = $(this).serialize();

        // post a response to the controller, but capture its output.  Don't redirect!
        $.post('/searches/saveSearch/' + dataString, data, function (response) {
            //console.log("did we return? ");
            // we get back a json that tells us which page to go to next
            var parsedResponse = JSON.parse(response);

            $('#myModal').modal('hide');
            // wonder if I couldn't just return a page response instead?
            window.location.href = '/documents/?orderId=' + parsedResponse['order_id'];
        }).fail(function (response) {
            console.log("failed " + response);
        });
    });
}


function emailSelection() {
    var toEmail = $('#email_address').val();
    var emailBody = $('#email_body').val();
    var selectionId = $('#current_selected_listing').val();
    $.ajax({
        type: 'POST',
        url: '/documents/selectionEmail/',
        data: 'data=' + JSON.stringify({
            'to_email': toEmail,
            'email_body': emailBody,
            'selection_id': selectionId
        }),
        selection: function (response) {
            var parsedResponse = JSON.parse(response);
        }
    })
}

function copyOrder() {
    window.open('/searches/copyOrder/?search_id=' + getSelectedSearchId(), '_blank');
}


function saveChain() {
    var selectedDocuments = []; // initialize empty array
    $(".search-tab .selected:checked").each(function () {
        selectedDocuments.push($(this).val());
    });

    var orderId = $('#order-id').val();

    var selectionData = {
        'selected_documents': selectedDocuments,
        'title': $('#chain-title').val(),
        'notes': $('#chain-notes').val(),
        'order_id': orderId
    };

    var dataString = 'data=' + JSON.stringify(selectionData);

    $.ajax({
        type: 'POST',
        url: '/searches/saveChain/',
        data: dataString,
        success: function (response) {
            var parsedResponse = JSON.parse(response);

            //update select menu add the new listing//
            $('#saved-selection option:last').after(
                '<option value="' + parsedResponse['selection_id'] + '">' + parsedResponse['selection_name'] + "</option>"
            );

            //load up that selection in another tab//
            loadNewTab(parsedResponse['selection_id'], true, window);

            //clear the unsaved tab//
            clearUnsavedSelectionTab();
        },
        error: function (response) {
            alert('there was an error with the post');
        }
    });
}

function clearUnsavedSelectionTab() {
    //remove all rows that have data.. leave the header//
    $('#selected-table tr').each(function (i, row) {
        if (i != 0) {
            row.remove();
        }
    });

    //set the badge count to zero.//
    $('#selection-badge').html(0);
}

function closeTab(searchId, root) {
    root.$('#searching-tab-' + searchId).remove();
    root.$('#search-tab-header-' + searchId).parent().remove();
}


function createTab(root, header, tab) {
    root.$('#myTab').find('li:last').after(header);
    root.$('.tab-content').append(tab);
}

function expandDetails(resultId, parentClass) {
    var isHistory = false;
    var clickedDoc = -1;
    var results = $('tr[data-result-id="' + resultId + '"]');

    if (results.length > 1) {
        results.each(function () {
            if ($(this).data('searchId') != 0) {
                if (parentClass.includes('fallout-reveal')) {
                    clickedDoc = $(this);
                }
            } else {
                if (parentClass.includes('new-fallout') && this.classList.contains('new-fallout')) {
                    clickedDoc = $(this);
                } else if (parentClass.includes('fallout-hidden') && this.classList.contains('fallout-hidden')) {
                    clickedDoc = $(this);
                } else if (parentClass.includes('fallout-history') && this.classList.contains('fallout-history')) {
                    clickedDoc = $(this);
                    isHistory = true;
                }
            }
        });
    } else {
        clickedDoc = results;
    }

    if (isHistory) {
        var detailsElements = $('#document-history-table').find('.' + resultId + '_details');
        var toggleElement = $('#document-history-table').find('#' + resultId + '-details-toggle');
    } else {
        var detailsElements = $('#searching-tab-' + clickedDoc.data('searchId')).find('#document-table').find('.' + resultId + '_details');
        var toggleElement = $('#searching-tab-' + clickedDoc.data('searchId')).find('#document-table').find('#' + resultId + '-details-toggle');
    }

    var flags = {};
    var direction = '';

    detailsElements.each(function () {
        if ($(this).is(':visible')) {
            $(this).fadeOut();
            direction = 'remove';
            flags = {'expanded': false};
        } else {
            $(this).fadeIn();
            direction = 'add';
            flags = {'expanded': true};
        }
    });

    updateClickedDocument(clickedDoc, direction, toggleElement);
    updateResultFlags([{'resultId': resultId, 'flags': flags}]);
}

function updateClickedDocument(clickedDoc, direction, toggleElement) {
    if (direction === 'add') {
        toggleElement.removeClass('fa fa-arrow-down');
        toggleElement.addClass('fa fa-arrow-up');
        clickedDoc.find('.header-placeholder').addClass('header');
        clickedDoc.find('.header').fadeIn();
        clickedDoc.children('td').addClass('body-padding');
    } else {
        toggleElement.removeClass('fa fa-arrow-up');
        toggleElement.addClass('fa fa-arrow-down');
        clickedDoc.find('.header-placeholder').removeClass('header');
        clickedDoc.find('.header').fadeOut();
        clickedDoc.children('td').removeClass('body-padding');
    }
    addRemoveBorders([{Class: '.grantor-col', direction: direction, side: 'left'},
        {Class: '.grantee-col', direction: direction, side: 'right'},
        {Class: '.legal-col', direction: direction, side: 'left'},
        {Class: '.legal-col', direction: direction, side: 'right'}], clickedDoc);
}

function addRemoveBorders(columns, clickedDoc) {
    for (let i = 0; i < columns.length; i++) {
        if (columns[i].direction === 'add') {
            clickedDoc.children(columns[i].Class).addClass('border-' + columns[i].side);
        } else {
            clickedDoc.children(columns[i].Class).removeClass('border-' + columns[i].side);
        }
    }
}

function updateResultFlags(resultsWithFlags) {

    $.ajax({
        type: 'POST',
        url: '/searches/set-flags/',
        data: {data: resultsWithFlags},
        success: function (response) {
            console.log(response)
        },
        error: function (response) {
            alert('there was an error with the post ' + response);
        }
    });
}

function updateAllResultFlags(searchId, flags) {
    $.ajax({
        type: 'POST',
        url: '/searches/set-flags-all/',
        data: {searchId: searchId, flags: flags},
        success: function (response) {
            console.log(response)
        },
        error: function (response) {
            alert('there was an error with the post ' + response);
        }
    });
}

function getSelectedRecords() {
    return $('.tab-pane.active').find('.selected:checked');
}

function exportResults() {
    var action = $(this).val();
    var tab = $('.nav-tabs').find('li.active');
    var id = tab.attr('id').replace('selection-tab-', '');

    // Reset the select box
    this.selectedIndex = 0;

    // No results to export, let the user know
    if (!getSelectedRecords().length) {
        showError(errors.empty_selection_export);
        return;
    }

    if (action === 'pdf') {
        window.location.href = '/documents/selection-pdf/' + id;
    }

    if (action === 'zip') {
        window.open('/documents/selection-zip/' + id);
    }

    if (action === 'email') {
        $('#current_selected_listing').val(id);
        $('#emailModal').modal('show');
    }
}

var errors = {
    'save_selection': 'Please save your search before saving any chains.',
    'empty_selection': 'Please select at least one document before saving a chain.',
    'empty_selection_export': 'Please select at least one document before creating an export.'
};

function showError(msg) {
    $('#save-search').find('.message').text(msg).end().slideDown();
}

function hideError() {
    $('#save-search').slideUp();
}

function fillGridFromString(event) {
    // use the event's target's id to get the quarter string
    var quartersString = escape($(event.target).val());
    var grid = event.data.grid;

    $.ajax({
        type: 'GET',
        url: '/searches/convertStringToGridArray/?quarters_string=' + quartersString,
        success: function (response) {
            var parsedResponse = JSON.parse(response);

            // pass in the grid we are supposed to fill
            fillGridFromArray(parsedResponse.quarters_array, grid);
        },
        error: function (response) {
            console.log('Quarters string could not be converted');
        }
    });
}

function fillGridFromArray(bitArray, table) {
    for (let i = 0; i < 16; i++) {
        const rowCells = table.find("tr").eq(i).find("td");
        for (let j = 0; j < 16; j++) {
            if (bitArray[i][j] === 1)
                rowCells.eq(j).addClass("selected");
            else
                rowCells.eq(j).removeClass("selected");
        }
    }
}

function fillStringFromGrid(table, quarter) {
    const grid = new Array(16);
    for (let i = 0; i < grid.length; i++) {
        grid[i] = new Array(16).fill(0);
    }

    for (let i = 0; i < 16; i++) {
        const rowCells = table.find("tr").eq(i).find("td");
        for (let j = 0; j < 16; j++) {
            if (rowCells.eq(j).hasClass("selected"))
                grid[i][j] = 1;
        }
    }

    $.ajax({
        type: 'GET',
        url: '/searches/convertGridArrayToString/?quarters_array=' + grid,
        success: function (response) {
            $(quarter).val(response.quarters_string);
        },
        error: function (response) {
            console.log('Quarters array could not be converted');
        }
    });
}

async function reloadSearchTab(searchId, root) {
    const response = await $.get('/documents/get-tab/', {searchId: searchId});
    const parsedResponse = JSON.parse(response);
    closeTab(searchId, root);
    createTab(root, parsedResponse.header, parsedResponse.tab);
    const newTab = root.$('#searching-tab-' + searchId);
    applyTabJavaScript(newTab);
}

/**
 * respond to clicks of Load More button at bottom of search results
 * @param event
 */
function onLoadMore(event) {
    event.preventDefault();
    updateLoadingUI($('#searching-tab-' + getSelectedSearchId()));
    loadNextPage(AUTOLOAD_EVENT.ON_LOAD_MORE);
}

/**
 * Initiate asynconous download of next set of records, aka "page" of records
 */
function loadNextPage(event, targetTabPane) {
    // When page load starts, load pagesPerSet number of pages and then wait
    // for the user to click Load More then load the next pagesPerSet number of pages
    // and so on until all pages in the set are loaded.
    // if the user changes to a new active tab, seamlessly continue on to loading records on the new tab
    // or if no loading is taking place and additional pages remain to be loaded on current tab
    // then initiate loading.


    var searchID = getSelectedSearchId();
    var activeTabPane = '#searching-tab-' + searchID;

    // if current pane is not target pane, then abort. If this isn't done, then updateLoadingUI
    // can cause the previous tab's auto loading report to be placed on the active tab
    if ((typeof targetTabPane != 'undefined') && activeTabPane != targetTabPane)
        return;

    var autoLoadParams = $('.auto-load-report', activeTabPane);

    // If user is switching tabs, but a auto loading is not in the middle of a set, then return
    //  because in that case the next set should not start loading
    if (event === AUTOLOAD_EVENT.TAB_SWITCH && autoLoadParams.data('currentPage') > 1
        && autoLoadParams.data('pageInSet') === 0) {
        /*
         console.log("aborted auto loading due to tab change. CurrentPage: " +
         autoLoadParams.data('currentPage') + " Page In Set: " + autoLoadParams.data('pageInSet') );
         */
        return;
    }

    // see note above LOADING COMPLETE in uploadLoadingUI() about when to stop loading
    // If loading is already complete, just update loading report
    if (getLoadingState(autoLoadParams) === AUTOLOAD_STATE.COMPLETE) {
        //console.log( 'loadNextPage Complete. Pane:' + activeTabPane );
        updateLoadingUI(activeTabPane);
        return;
    }

    // Increment to next page
    var currentPage = autoLoadParams.data('currentPage') + 1; // currentPage is a COUNT
    var pageInSet = autoLoadParams.data('pageInSet') + 1; // pageInset is an INDEX

    autoLoadParams.data('currentPage', currentPage);
    autoLoadParams.data('pageInSet', pageInSet);

    var url = autoLoadParams.data('url') + '&page=' + autoLoadParams.data('currentPage');
    var documentsTable = $('#document-table', activeTabPane);

    var loadingButton = $('.load-more', activeTabPane);
    loadingButton.prop('disabled', true);
    loadingButton.hide();

    $.get(url, function (data) {
        var html = $(data);
        var summaries = html.find(".document-summary");
        var details = html.find(".document-details");

        var documentsLoaded = autoLoadParams.data('documentsLoaded');
        // console.log( "Documents Loaded: " + autoLoadParams.data('documentsLoaded') );

        // Append records to the listing shown to the user
        for (var x = 0; x < summaries.length; x++) {
            // Uncomment to show row indexing data
            //prefixRowDebugData( autoLoadParams, summaries[x], documentsLoaded, x );
            documentsTable.append(summaries[x]);
            documentsTable.append(details[2 * x]);
            documentsTable.append(details[(2 * x) + 1]);
        }

        documentsLoaded += summaries.length;

        autoLoadParams.data('documentsLoaded', documentsLoaded);

        applyTabJavaScript($(activeTabPane));

        updateLoadingUI(activeTabPane);
    });
}


function toggleWatchButton(isFinalChain) {
    var button = $('.btn-watch-for-release');

    if (isFinalChain) {
        $(button).show();
    } else {
        $(button).hide();
    }
}


/**
 * Write prefix information into the document row before the checkbox
 *
 * @param autoLoadDebug
 * @param row - the row just loaded to modify
 * @param documentsLoaded - current document loaded up to end of last page
 * @param loopIndex - index in loop of curent documents being parsed from ajax response
 */
function prefixRowDebugData(autoLoadParams, row, documentsLoaded, loopIndex) {
    // P = Current Page
    // X = Index in current page result
    // # = absolute index of entire result set
    var absoluteIdx = documentsLoaded + loopIndex; // This is count not index
    var autoLoadParams = "#:" + absoluteIdx + " Page:" + autoLoadParams.data('currentPage') + " XinPage: " + loopIndex;
    var span = $(row).find('.autoload-debug');
    var input = $(row).find('input:checkbox');
    if (span.length) {
        span.html(autoLoadParams);
    } else if (input.length) {
        input.before(autoLoadParams);
    }
}

var AUTOLOAD_STATE = {
    UNKNOWN: 'unknown',
    COMPLETE: 'complete',
    IN_PROGRESS: 'in_progress',
    WAIT_FOR_USER: 'wait_for_user'
};

function getLoadingState(autoLoadParams) {
    if (autoLoadParams.data('currentPage') >= autoLoadParams.data('maxPages')) {
        return AUTOLOAD_STATE.COMPLETE;
    }

    return AUTOLOAD_STATE.IN_PROGRESS;
}

/**
 * Update the loading report div at the bottom of search results
 */
function updateLoadingUI(targetTabPane) {
    const autoLoadParams = $('.auto-load-report', targetTabPane);
    let html = '';

    // Wait for user is default state which will be overridden below if loading is in progress.
    const loadingState = getLoadingState(autoLoadParams);
    /*
     console.log( "currentPage: " + autoLoadParams.data("currentPage") +
     " pageInSet: " + autoLoadParams.data('pageInSet') +
     " pagesPerSet: " +  autoLoadParams.data('pagesPerSet') +
     " LastPage: " + autoLoadParams.data('maxPages') );
     */

    switch (loadingState) {
        case AUTOLOAD_STATE.COMPLETE:
            // Reset pageInSet so loadNextPage won't run if user switches tabs
            autoLoadParams.data('pageInSet', 0);

            // no more records to load, remove the Load More button
            if (autoLoadParams.data('documentCount') < 1)
                html = "There are no matching documents.";
            else {
                const targetTabSearchId = targetTabPane.split('-')[targetTabPane.split('-').length - 1];
                // TODO: TEMPORARY SO THAT ACTUAL COUNT LOADED IS DISPLAYED WHEN COMPLETE
                const loadedDocCount = $(`.document-summary[data-search-id="${targetTabSearchId}"]`).not('.fallout-hidden').length;
                const totalDocCount = parseInt($(`#document-count-${targetTabSearchId}`).text());
                html = `${loadedDocCount} of ${totalDocCount} documents loaded`;
            }
            break;
        case AUTOLOAD_STATE.IN_PROGRESS:
            html = "Loaded " + autoLoadParams.data('documentsLoaded') + " of "
                + autoLoadParams.data('documentCount') + " documents. Loading in progress...";
            loadNextPage(AUTOLOAD_EVENT.CONTINUE, targetTabPane);
            break;
    }

    $('.auto-load-report', targetTabPane).html(html);
}

function getSelectedSearchId() {
    return $('#myTab').find('li a.active').data('searchId');
}

function getSelectedDocs() {
    return $('#searching-tab-' + getSelectedSearchId()).find(".selected:checked");
}

function getSelectedResultIdsOnCurrentTab() {
    return $('#searching-tab-' + getSelectedSearchId()).find(".selected:checked").map(function (index, element) {
        return $(element).parents('.document-summary').data('resultId');
    }).get();
}

function getOrderId() {
    return $('#order-id').val();
}

function getPlantId() {
    return $('#plant-id').val();
}

function enableSelect2(items, index) {
    var plantId = $('#search-filter-plant-id').val();

    $.each(items, function () {
        let field = '';
        if ('autoCompleteField' in $(this).data()) {
            field = '/' + $(this).data('autoCompleteField');
        }
        $(this).select2({
            maximumSelectionLength: 1,
            ajax: { // every time the user types in the box, we call this controller to get a list of possible candidates
                url: '/auto-complete/' + plantId + '/' + $(this).data('autoCompleteType') + field,
                dataType: 'json',
                quietMillis: 250,
                delay: 500,
                processResults: function (data, page) {  // I set the controller above to return a json in the form the select2 wants
                    return {results: data.items};
                },
                cache: true
            }
        });
    });

    items.filter('[id$="' + index + '_addition"]').on('change', function () {
        $('[id$="' + index + '_addition_display_value"]').val($(this).val() ? $(this).val()[0] : '');
    });
}

function enableSelect2Tags(item) {
    item.select2({
        tags: true,
    });
}

async function reloadFinalChain() {
    const finalTabId = $('#final-id').val();
    await reloadSearchTab(finalTabId, window);
}


function switchTab(searchId) {
    const tab = $(`.search-tab-button[data-search-id="${searchId}"]`);
    $('.search-tab-button').removeClass('active');
    tab.addClass('active');

    $('.tab-pane').removeClass('active');
    $(tab.data('target')).addClass('active');

    const isFinalChain = tab.parent().hasClass('final-chain');
    toggleWatchButton(isFinalChain);

    // Begin loading next page of records on current tab
    loadNextPage(AUTOLOAD_EVENT.TAB_SWITCH);
}

//this function just superficially displays the shading options in the documents
/* kept in case UI for background shading is again desired
function shading(docType) {

    if (docType == 'related') {
        if (document.getElementById('checkbox-related').checked) {
            $('.related-document').css('background-color', '#c4d5e8');
            $('.search-results table tbody tr.related-document .header').css('background-color', '#c4d5e8')
            $('.search-results table tbody tr.related-document .header-placeholder').css('background-color', '#c4d5e8')
        } else {
            $('.related-document').css('background-color', 'transparent');
            $('.search-results table tbody tr.related-document .header').css('background-color', 'transparent')
            $('.search-results table tbody tr.related-document .header-placeholder').css('background-color', 'transparent')
        }
    }
    if (docType == 'primary') {
        if (document.getElementById('checkbox-primary').checked) {
            $('.search-results .document-summary').css('background-color', '#e5e5e5');
            $('.search-results .document-summary .header').css('background-color', '#e5e5e5');
            $('.search-results .document-summary .header-placeholder').css('background-color', '#e5e5e5');
            if (document.getElementById('checkbox-related').checked) {
                $('.related-document').css('background-color', '#c4d5e8');
                $('.search-results table tbody tr.related-document .header').css('background-color', '#c4d5e8')
                $('.search-results table tbody tr.related-document .header-placeholder').css('background-color', '#c4d5e8')
            } else {
                $('.related-document').css('background-color', 'transparent');
                $('.search-results table tbody tr.related-document .header').css('background-color', 'transparent')
                $('.search-results table tbody tr.related-document .header-placeholder').css('background-color', 'transparent')
            }
        } else {
            $('.search-results .document-summary').css('background-color', 'transparent');
            $('.search-results .document-summary .header').css('background-color', 'transparent');
            $('.search-results .document-summary .header-placeholder').css('background-color', 'transparent');
            if (document.getElementById('checkbox-related').checked) {
                $('.related-document').css('background-color', '#c4d5e8');
                $('.search-results table tbody tr.related-document .header').css('background-color', '#c4d5e8')
                $('.search-results table tbody tr.related-document .header-placeholder').css('background-color', '#c4d5e8')
            } else {
                $('.related-document').css('background-color', 'transparent');
                $('.search-results table tbody tr.related-document .header').css('background-color', 'transparent')
                $('.search-results table tbody tr.related-document .header-placeholder').css('background-color', 'transparent')
            }
        }
    }

}*/

function addDocTags(documentIds) {
    $('#tag-documents-ids').val(JSON.stringify(documentIds));
    $('.tag-documents-tags').prop('checked', false);
    $('#tag-documents-modal .lds-spinner').addClass('hide');
    $('#tag-documents-content').removeClass('hide');
    $('#tag-modal-save').prop('disabled', false);

    $('#tag-documents-modal').modal('show');
}

function createBatchFromSearch(searchId) {
    $('#batch-search-id').val(searchId);
    $('#create-batch-content').removeClass('hide');
    $('#create-batch-modal-save').prop('disabled', false);

    $('#create-batch-from-search-modal').modal('show');
}
